(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joyprotyn-ad-content"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynReviewToggle = (root) => {
    if (!root || root.dataset.jpAdReviewToggleReady === 'true') return;

    const quotes = root.querySelector('.jp-ad-review-quotes');
    const toggle = root.querySelector('[data-jp-review-toggle]');
    const label = toggle ? toggle.querySelector('[data-jp-review-toggle-label]') : null;
    if (!quotes || !toggle || !label) return;

    toggle.addEventListener('click', () => {
      const expanded = quotes.dataset.expanded !== 'true';
      quotes.dataset.expanded = String(expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? 'fewer reviews' : 'more reviews';
    });

    root.dataset.jpAdReviewToggleReady = 'true';
  };

  const initializeJoyprotynLightbox = (root) => {
    if (!root || root.dataset.jpAdLightboxReady === 'true') return;

    const dialog = root.querySelector('[data-jp-ad-lightbox]');
    const frame = root.querySelector('.jp-ad-lightbox-inner');
    const preview = root.querySelector('[data-jp-ad-lightbox-image]');
    if (!dialog || !frame || !preview) return;

    const fitPreviewToViewport = () => {
      const naturalWidth = Number(preview.dataset.naturalWidth);
      const naturalHeight = Number(preview.dataset.naturalHeight);
      if (!naturalWidth || !naturalHeight) return;

      const compact = window.matchMedia('(max-width: 720px)').matches;
      const availableWidth = compact
        ? Math.max(220, window.innerWidth - 20)
        : Math.max(220, Math.min(1480, window.innerWidth - 32));
      const availableHeight = compact
        ? Math.max(220, window.innerHeight - 20)
        : Math.max(220, window.innerHeight - 32);
      const scale = Math.min(availableWidth / naturalWidth, availableHeight / naturalHeight);
      const displayWidth = Math.round(naturalWidth * scale);
      const displayHeight = Math.round(naturalHeight * scale);

      if (compact) {
        dialog.style.width = `${displayWidth}px`;
        dialog.style.height = `${displayHeight}px`;
      } else {
        dialog.style.removeProperty('width');
        dialog.style.removeProperty('height');
      }

      preview.style.setProperty('width', `${displayWidth}px`, 'important');
      preview.style.setProperty('height', `${displayHeight}px`, 'important');
      preview.style.setProperty('max-width', '100%', 'important');
      preview.style.setProperty('max-height', '100%', 'important');
      preview.style.setProperty('object-fit', 'contain', 'important');
      preview.style.setProperty('object-position', 'center', 'important');
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-jp-ad-zoom]');
      if (trigger && root.contains(trigger)) {
        const card = trigger.closest('.jp-ad-image-card, .jp-ad-detail-card, .jp-ad-outcome-card');
        const source = card ? card.querySelector('img') : null;
        if (!source) return;

        const naturalWidth = source.naturalWidth || Number(source.getAttribute('width')) || 1200;
        const naturalHeight = source.naturalHeight || Number(source.getAttribute('height')) || 900;
        preview.dataset.naturalWidth = naturalWidth;
        preview.dataset.naturalHeight = naturalHeight;
        preview.width = naturalWidth;
        preview.height = naturalHeight;
        preview.src = source.src || source.currentSrc;
        preview.alt = source.alt || '';
        fitPreviewToViewport();
        if (!dialog.open) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-jp-ad-lightbox-close]');
      if (closeButton && root.contains(closeButton)) dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      preview.removeAttribute('src');
      preview.alt = '';
      preview.style.removeProperty('width');
      preview.style.removeProperty('height');
      preview.style.removeProperty('max-width');
      preview.style.removeProperty('max-height');
      preview.style.removeProperty('object-fit');
      preview.style.removeProperty('object-position');
      dialog.style.removeProperty('width');
      dialog.style.removeProperty('height');
      delete preview.dataset.naturalWidth;
      delete preview.dataset.naturalHeight;
    });

    window.addEventListener('resize', () => {
      if (dialog.open) fitPreviewToViewport();
    });

    root.dataset.jpAdLightboxReady = 'true';
  };

  document.querySelectorAll('[data-jp-ad-flow]').forEach((root) => {
    initializeJoyprotynReviewToggle(root);
    initializeJoyprotynLightbox(root);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-jp-ad-flow]');
    initializeJoyprotynReviewToggle(root);
    initializeJoyprotynLightbox(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joyprotyn-egg-comparison"] && !Shopify.designMode) return;
  try {
    
  const moveJoyprotynEggComparison = (section) => {
    if (!section || section.dataset.jpEggCompareMoved === 'true') return;

    const flow = document.querySelector('[data-jp-ad-flow]');
    const target = flow ? flow.querySelector('.jp-ad-outcomes') : null;
    if (!target) return;

    target.insertAdjacentElement('afterend', section);
    section.dataset.jpEggCompareMoved = 'true';
  };

  document.querySelectorAll('[data-jp-egg-compare]').forEach(moveJoyprotynEggComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jp-egg-compare]');
    if (section) moveJoyprotynEggComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joyprotyn-feather-comparison"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynFeatherComparison = (section) => {
    if (!section || section.dataset.jpFeatherCompareReady === 'true') return;

    const slider = section.querySelector('[data-jp-feather-slider]');
    const range = section.querySelector('.jp-ad-feather-range');
    if (!slider || !range) return;

    const updatePosition = () => {
      slider.style.setProperty('--jp-feather-position', `${range.value}%`);
    };

    range.addEventListener('input', updatePosition);
    updatePosition();
    section.dataset.jpFeatherCompareReady = 'true';
  };

  const moveJoyprotynFeatherComparison = (section) => {
    if (!section) return;

    const flow = document.querySelector('[data-jp-ad-flow]');
    const target = flow ? flow.querySelector('.jp-ad-outcomes') : null;
    if (!target) return;

    if (target.nextElementSibling !== section) {
      target.insertAdjacentElement('afterend', section);
    }
  };

  const prepareJoyprotynFeatherComparison = (section) => {
    initializeJoyprotynFeatherComparison(section);
    moveJoyprotynFeatherComparison(section);
    requestAnimationFrame(() => moveJoyprotynFeatherComparison(section));
    window.setTimeout(() => moveJoyprotynFeatherComparison(section), 160);
  };

  document.querySelectorAll('[data-jp-feather-compare]').forEach(prepareJoyprotynFeatherComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jp-feather-compare]');
    if (section) prepareJoyprotynFeatherComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-bundle-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var preloadedImages = {};

    function preloadImage(src) {
      if (!src || preloadedImages[src]) return;

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
      preloadedImages[src] = image;
    }

    function initIntroCollapse(root) {
      var scope = root || document;
      var intros = scope.querySelectorAll('[data-collapsible-intro]');

      intros.forEach(function (intro) {
        if (intro.dataset.collapseReady === 'true') return;

        var toggle = intro.querySelector('[data-intro-toggle]');

        if (!toggle) return;

        intro.dataset.collapseReady = 'true';

        toggle.addEventListener('click', function () {
          var expanded = intro.classList.toggle('is-expanded');

          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          toggle.textContent = expanded
            ? toggle.getAttribute('data-collapse-label')
            : toggle.getAttribute('data-expand-label');
        });
      });
    }

    function initQuantitySteppers(root) {
      var scope = root || document;
      var steppers = scope.querySelectorAll('[data-quantity-stepper]');

      steppers.forEach(function (stepper) {
        if (stepper.dataset.quantityReady === 'true') return;

        var input = stepper.querySelector('input[name="quantity"]');
        var decrease = stepper.querySelector('[data-quantity-decrease]');
        var increase = stepper.querySelector('[data-quantity-increase]');

        if (!input || !decrease || !increase) return;

        stepper.dataset.quantityReady = 'true';

        function limits() {
          var minimum = Number(input.min || 1);
          var maximum = input.max === '' ? Number.POSITIVE_INFINITY : Number(input.max);
          var increment = Number(input.step || 1);

          return {
            minimum: Number.isFinite(minimum) ? minimum : 1,
            maximum: Number.isFinite(maximum) ? maximum : Number.POSITIVE_INFINITY,
            increment: Number.isFinite(increment) && increment > 0 ? increment : 1
          };
        }

        function normalizedValue() {
          var controlLimits = limits();
          var value = Number(input.value);

          if (!Number.isFinite(value)) value = controlLimits.minimum;
          return Math.min(controlLimits.maximum, Math.max(controlLimits.minimum, value));
        }

        function syncButtons() {
          var controlLimits = limits();
          var value = normalizedValue();

          input.value = String(value);
          decrease.disabled = value <= controlLimits.minimum;
          increase.disabled = value >= controlLimits.maximum;
        }

        function changeQuantity(direction) {
          var controlLimits = limits();
          var nextValue = normalizedValue() + (controlLimits.increment * direction);

          input.value = String(Math.min(controlLimits.maximum, Math.max(controlLimits.minimum, nextValue)));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          syncButtons();
        }

        decrease.addEventListener('click', function () {
          changeQuantity(-1);
        });

        increase.addEventListener('click', function () {
          changeQuantity(1);
        });

        input.addEventListener('input', syncButtons);
        input.addEventListener('change', syncButtons);
        input.addEventListener('blur', syncButtons);
        syncButtons();
      });
    }

    function initGallery(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.jpvs-pdp-hero');

      sections.forEach(function (section) {
        if (section.dataset.galleryReady === 'true') return;

        var mainImage = section.querySelector('.jpvs-hero-image');
        var thumbs = section.querySelectorAll('[data-gallery-thumb]');

        if (!mainImage || thumbs.length === 0) return;

        section.dataset.galleryReady = 'true';
        mainImage.decoding = 'async';

        thumbs.forEach(function (thumb) {
          preloadImage(thumb.getAttribute('data-gallery-src'));

          thumb.addEventListener('mouseenter', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('focus', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-gallery-src');
            var srcset = thumb.getAttribute('data-gallery-srcset');
            var alt = thumb.getAttribute('data-gallery-alt') || '';

            if (!src) return;

            thumbs.forEach(function (item) {
              item.classList.remove('is-active');
              item.setAttribute('aria-current', 'false');
            });

            thumb.classList.add('is-active');
            thumb.setAttribute('aria-current', 'true');

            if (srcset) {
              mainImage.srcset = srcset;
            } else {
              mainImage.removeAttribute('srcset');
            }

            mainImage.src = src;
            mainImage.alt = alt;
          });
        });
      });
    }

    function initVariantOptions(root) {
      var scope = root || document;
      var forms = scope.querySelectorAll('.jpvs-product-form');

      forms.forEach(function (form) {
        if (form.dataset.variantReady === 'true') return;

        var radios = form.querySelectorAll('[data-variant-radio]');
        var variantIdInput = form.querySelector('[data-selected-variant-id]');
        var addButton = form.querySelector('[data-add-to-cart]');
        var checkoutButton = form.querySelector('[data-checkout]');
        var priceTargets = form.querySelectorAll('[data-variant-price-target]');
        var comparePriceTargets = form.querySelectorAll('[data-variant-compare-target]');
        var heroSection = form.closest('.jpvs-pdp-hero');
        var mainImage = heroSection ? heroSection.querySelector('.jpvs-hero-image') : null;
        var galleryThumbs = heroSection ? heroSection.querySelectorAll('[data-gallery-thumb]') : [];


        if (radios.length === 0) return;

        form.dataset.variantReady = 'true';

        function selectedRadio() {
          var selected = form.querySelector('[data-variant-radio]:checked');
          var requestedVariantId = new URLSearchParams(window.location.search).get('variant');

          if (requestedVariantId) {
            for (var index = 0; index < radios.length; index += 1) {
              var requestedRadio = radios[index];
              var requestedRadioAvailable = requestedRadio.getAttribute('data-variant-available') === 'true';

              if (requestedRadio.value === requestedVariantId && requestedRadioAvailable) {
                requestedRadio.checked = true;
                return requestedRadio;
              }
            }
          }

          return selected || radios[0];
        }

        function syncVariantMedia(radio) {
          if (!radio || !mainImage) return;

          var mediaId = radio.getAttribute('data-variant-media-id') || '';
          var src = radio.getAttribute('data-variant-media-src') || '';
          var srcset = radio.getAttribute('data-variant-media-srcset') || '';
          var alt = radio.getAttribute('data-variant-media-alt') || '';

          if (!src) return;

          if (srcset) {
            mainImage.srcset = srcset;
          } else {
            mainImage.removeAttribute('srcset');
          }

          mainImage.src = src;
          mainImage.alt = alt;

          galleryThumbs.forEach(function (thumb) {
            var isActive = mediaId !== '' && thumb.getAttribute('data-gallery-media-id') === mediaId;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }

        function syncVariant(radio) {
          if (!radio) return;

          var price = radio.getAttribute('data-variant-price') || '';
          var comparePrice = radio.getAttribute('data-variant-compare-price') || '';
          var hasComparePrice = radio.getAttribute('data-variant-has-compare-price') === 'true';
          var available = radio.getAttribute('data-variant-available') === 'true';

          syncVariantMedia(radio);

          priceTargets.forEach(function (target) {
            target.textContent = price;
          });

          comparePriceTargets.forEach(function (target) {
            target.textContent = comparePrice;
            target.hidden = !hasComparePrice;
          });

          if (addButton) {
            if (available) {
              addButton.disabled = false;
              addButton.textContent = addButton.getAttribute('data-add-label') + ' - ' + price;
            } else {
              addButton.disabled = true;
              addButton.textContent = addButton.getAttribute('data-sold-out-label');
            }
          }

          if (checkoutButton) {
            checkoutButton.disabled = !available;
            checkoutButton.textContent = available
              ? checkoutButton.getAttribute('data-checkout-label')
              : checkoutButton.getAttribute('data-sold-out-label');
          }

          if (variantIdInput && variantIdInput.value !== radio.value) {
            variantIdInput.value = radio.value;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            syncVariant(radio);
          });
        });

        syncVariant(selectedRadio());
      });
    }

    function sealEventElement(event) {
      var detailElement = event && event.detail ? event.detail.element : null;

      if (detailElement && detailElement.jquery) {
        detailElement = detailElement[0];
      }

      if (detailElement instanceof Element) {
        return detailElement;
      }

      return event && event.target instanceof Element ? event.target : null;
    }

    function markSealReady(element) {
      if (!element) return;

      var shell = element.matches && element.matches('[data-jpvs-seal-shell]')
        ? element
        : element.closest && element.closest('[data-jpvs-seal-shell]');

      if (!shell) return;

      shell.classList.add('is-ready');
      shell.classList.remove('is-timeout');
      shell.setAttribute('aria-busy', 'false');
    }

    function formatSealMoney(minorUnits) {
      var currency = window.Shopify && window.Shopify.currency
        ? window.Shopify.currency.active
        : 'USD';
      var locale = document.documentElement.lang || 'en';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency
        }).format(minorUnits / 100);
      } catch (error) {
        return (minorUnits / 100).toFixed(2) + ' ' + currency;
      }
    }

    function syncSealButtonPrice(event) {
      var element = sealEventElement(event);
      var form = element ? element.closest('.jpvs-product-form') : null;
      var price = event && event.detail ? Number(event.detail.price) : NaN;

      markSealReady(element);

      if (!form || !Number.isFinite(price)) return;

      var selectedVariant = form.querySelector('[data-variant-radio]:checked');
      var addButton = form.querySelector('[data-add-to-cart]');

      if (
        !selectedVariant
        || selectedVariant.getAttribute('data-variant-available') !== 'true'
        || !addButton
      ) {
        return;
      }

      addButton.textContent = addButton.getAttribute('data-add-label')
        + ' - '
        + formatSealMoney(price);
    }

    function initSealWidgets(root, refreshSeal) {
      var scope = root || document;
      var shells = scope.querySelectorAll('[data-jpvs-seal-shell]');

      shells.forEach(function (shell) {
        if (shell.dataset.sealReady === 'true') return;

        shell.dataset.sealReady = 'true';

        if (shell.querySelector('.sealsubs-container')) {
          markSealReady(shell);
          return;
        }

        var observer = new MutationObserver(function () {
          if (!shell.querySelector('.sealsubs-container')) return;

          markSealReady(shell);
          observer.disconnect();
        });

        observer.observe(shell, { childList: true, subtree: true });

        window.setTimeout(function () {
          if (shell.classList.contains('is-ready')) return;

          shell.classList.add('is-timeout');
          shell.setAttribute('aria-busy', 'false');
        }, 8000);
      });

      if (
        refreshSeal
        && window.SealSubs
        && typeof window.SealSubs.refresh === 'function'
      ) {
        window.SealSubs.refresh();
      }
    }

    if (!window.jpvsSealBridgeReady) {
      window.jpvsSealBridgeReady = true;

      document.addEventListener('sealsubs:subscription_widget_created', function (event) {
        markSealReady(sealEventElement(event));
      });

      document.addEventListener('sealsubs:selling_plan_changed', function (event) {
        markSealReady(sealEventElement(event));
      });

      document.addEventListener('sealsubs:price_update', syncSealButtonPrice);
    }

    function init(root, refreshSeal) {
      initIntroCollapse(root);
      initQuantitySteppers(root);
      initGallery(root);
      initVariantOptions(root);
      initSealWidgets(root, refreshSeal);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-bundle-videostrip-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const disableReviewAutoScroll = (widget) => {
      if (!widget) return;

      widget.setAttribute('data-not-scroll-to', 'true');

      const judgeMe = typeof jdgm !== 'undefined' ? jdgm : window.jdgm;

      if (judgeMe && typeof judgeMe.$ === 'function') {
        const pluginWidget = judgeMe.$(widget);
        pluginWidget.data('not-scroll-to', true);
        pluginWidget.data('notScrollTo', true);
      }

      return judgeMe;
    };

    const bindReviewPaginationStability = (section) => {
      if (section.dataset.jpbundleReviewPaginationReady === 'true') return;

      const settlePluginStyles = (widget) => {
        const body = widget.querySelector('.jdgm-rev-widg__body');
        const spinner = widget.querySelector('.jdgm-rev-widg__paginate-spinner-wrapper');

        if (body) {
          ['display', 'height', 'overflow', 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom'].forEach((property) => {
            body.style.removeProperty(property);
          });
        }

        if (spinner) spinner.style.display = 'none';
      };

      const beginReviewLoading = (targetPage) => {
        const widget = section.querySelector('.jpbundle-judgeme .jdgm-rev-widg');
        const body = widget && widget.querySelector('.jdgm-rev-widg__body');
        const previousReviews = body && body.querySelector('.jdgm-rev-widg__reviews');

        if (!widget || !body || !previousReviews || widget.classList.contains('is-jpbundle-review-loading')) return;

        const judgeMe = disableReviewAutoScroll(widget);
        const originalPluginScrollTo = judgeMe && typeof judgeMe.scrollTo === 'function' ? judgeMe.scrollTo : null;
        const blockedPluginScrollTo = originalPluginScrollTo ? () => {} : null;

        if (blockedPluginScrollTo) judgeMe.scrollTo = blockedPluginScrollTo;

        const stableHeight = Math.ceil(widget.getBoundingClientRect().height);
        if (stableHeight < 1) return;

        const previousSignature = previousReviews.textContent;

        widget.style.setProperty('--jpbundle-review-stable-height', stableHeight + 'px');
        widget.classList.add('is-jpbundle-review-stable', 'is-jpbundle-review-loading');
        widget.setAttribute('aria-busy', 'true');

        const stableScrollLeft = window.scrollX;
        const stableScrollTop = window.scrollY;
        let completed = false;
        let observer = null;
        let fallback = null;
        let transitionTimer = null;
        let scrollLockFrame = 0;

        const holdScrollPosition = () => {
          if (completed) return;

          if (Math.abs(window.scrollX - stableScrollLeft) > 0.5 || Math.abs(window.scrollY - stableScrollTop) > 0.5) {
            window.scrollTo({ left: stableScrollLeft, top: stableScrollTop, behavior: 'instant' });
          }

          scrollLockFrame = window.requestAnimationFrame(holdScrollPosition);
        };

        scrollLockFrame = window.requestAnimationFrame(holdScrollPosition);

        const cleanup = () => {
          if (completed) return;
          completed = true;

          if (observer) observer.disconnect();
          if (fallback) window.clearTimeout(fallback);
          if (transitionTimer) window.clearTimeout(transitionTimer);
          if (scrollLockFrame) window.cancelAnimationFrame(scrollLockFrame);

          if (judgeMe && blockedPluginScrollTo && judgeMe.scrollTo === blockedPluginScrollTo) {
            judgeMe.scrollTo = originalPluginScrollTo;
          }

          widget.classList.remove('is-jpbundle-review-loading', 'is-jpbundle-review-stable');
          widget.removeAttribute('aria-busy');
          widget.style.removeProperty('--jpbundle-review-stable-height');
        };

        const revealNewReviews = (nextReviews) => {
          if (completed) return;

          if (observer) observer.disconnect();
          if (fallback) window.clearTimeout(fallback);

          nextReviews.classList.add('is-jpbundle-review-entering');
          widget.classList.remove('is-jpbundle-review-loading');

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              nextReviews.classList.add('is-jpbundle-review-visible');
            });
          });

          transitionTimer = window.setTimeout(() => {
            settlePluginStyles(widget);
            nextReviews.classList.remove('is-jpbundle-review-entering', 'is-jpbundle-review-visible');
            cleanup();
          }, 460);
        };

        const inspectReplacement = () => {
          const currentBody = widget.querySelector('.jdgm-rev-widg__body');
          const nextReviews = currentBody && currentBody.querySelector('.jdgm-rev-widg__reviews');
          const activePage = currentBody && currentBody.querySelector('.jdgm-paginate__page.jdgm-curt');
          const currentPage = activePage ? activePage.getAttribute('data-page') : null;

          if (!nextReviews || !nextReviews.querySelector('.jdgm-rev')) return false;
          if (targetPage && currentPage !== targetPage) return false;
          if (!targetPage && nextReviews === previousReviews && nextReviews.textContent === previousSignature) return false;

          revealNewReviews(nextReviews);
          return true;
        };

        observer = new MutationObserver(inspectReplacement);

        observer.observe(widget, {
          childList: true,
          subtree: true
        });

        fallback = window.setTimeout(() => {
          if (inspectReplacement()) return;
          settlePluginStyles(widget);
          cleanup();
        }, 8000);
      };

      section.addEventListener('click', (event) => {
        const control = event.target instanceof Element ? event.target.closest('.jdgm-paginate__page') : null;
        if (!control || control.classList.contains('jdgm-curt')) return;

        const widget = section.querySelector('.jpbundle-judgeme .jdgm-rev-widg');
        if (widget && widget.classList.contains('is-jpbundle-review-loading')) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        beginReviewLoading(control.getAttribute('data-page'));
      }, true);

      section.addEventListener('change', (event) => {
        if (!(event.target instanceof Element) || !event.target.matches('.jdgm-sort-dropdown')) return;
        beginReviewLoading(null);
      }, true);

      section.dataset.jpbundleReviewPaginationReady = 'true';
    };

    const initializeBundleReviews = (scope) => {
      const root = scope || document;
      const sections = [];

      if (root.matches && root.matches('[data-jpbundle-review-section]')) sections.push(root);
      if (root.querySelectorAll) sections.push(...root.querySelectorAll('[data-jpbundle-review-section]'));

      sections.forEach((section) => {
        bindReviewPaginationStability(section);
        if (section.dataset.jpbundleReviewReady === 'true') return;

        let observer = section.jpbundleReviewObserver || null;

        const syncReviewSummary = () => {
          const widget = section.querySelector('.jdgm-rev-widg');
          if (!widget) return false;

          disableReviewAutoScroll(widget);

          const sourceRows = Array.from(widget.querySelectorAll('.jdgm-histogram__row[data-rating]'));
          const rating = widget.getAttribute('data-average-rating');
          const reviewCount = widget.getAttribute('data-number-of-reviews');
          const score = section.querySelector('[data-jpbundle-review-score]');

          if (score && rating) score.textContent = rating;

          sourceRows.forEach((sourceRow) => {
            const ratingValue = sourceRow.getAttribute('data-rating');
            const targetRow = section.querySelector('[data-jpbundle-rating-row="' + ratingValue + '"]');
            if (!targetRow) return;

            const frequency = sourceRow.getAttribute('data-frequency') || '0';
            const percentage = sourceRow.getAttribute('data-percentage') || '0';
            const bar = targetRow.querySelector('b');
            const count = targetRow.querySelector('em');

            if (bar) bar.style.width = percentage + '%';
            if (count) count.textContent = frequency;
          });

          if (!rating || !reviewCount || sourceRows.length < 5) return false;

          section.dataset.jpbundleReviewReady = 'true';
          if (observer) observer.disconnect();
          section.jpbundleReviewObserver = null;
          return true;
        };

        if (syncReviewSummary()) return;

        observer = new MutationObserver(() => {
          if (!syncReviewSummary()) return;
          observer.disconnect();
        });

        section.jpbundleReviewObserver = observer;
        observer.observe(section, {
          attributes: true,
          attributeFilter: ['data-average-rating', 'data-number-of-reviews', 'data-frequency', 'data-percentage'],
          childList: true,
          subtree: true
        });
      });
    };

    const bootBundleReviews = () => {
      initializeBundleReviews(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootBundleReviews, { once: true });
    } else {
      bootBundleReviews();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeBundleReviews(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-compact-ad-content"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynCompactReviewToggle = (root) => {
    if (!root || root.dataset.jpcAdReviewToggleReady === 'true') return;

    const quotes = root.querySelector('.jpc-ad-review-quotes');
    const toggle = root.querySelector('[data-jpc-review-toggle]');
    const label = toggle ? toggle.querySelector('[data-jpc-review-toggle-label]') : null;
    if (!quotes || !toggle || !label) return;

    toggle.addEventListener('click', () => {
      const expanded = quotes.dataset.expanded !== 'true';
      quotes.dataset.expanded = String(expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? 'fewer reviews' : 'more reviews';
    });

    root.dataset.jpcAdReviewToggleReady = 'true';
  };

  const initializeJoyprotynCompactLightbox = (root) => {
    if (!root || root.dataset.jpcAdLightboxReady === 'true') return;

    const dialog = root.querySelector('[data-jpc-ad-lightbox]');
    const frame = root.querySelector('.jpc-ad-lightbox-inner');
    const preview = root.querySelector('[data-jpc-ad-lightbox-image]');
    if (!dialog || !frame || !preview) return;

    const fitPreviewToViewport = () => {
      const naturalWidth = Number(preview.dataset.naturalWidth);
      const naturalHeight = Number(preview.dataset.naturalHeight);
      if (!naturalWidth || !naturalHeight) return;

      const compact = window.matchMedia('(max-width: 720px)').matches;
      const availableWidth = compact
        ? Math.max(220, window.innerWidth - 20)
        : Math.max(220, Math.min(1480, window.innerWidth - 32));
      const availableHeight = compact
        ? Math.max(220, window.innerHeight - 20)
        : Math.max(220, window.innerHeight - 32);
      const scale = Math.min(availableWidth / naturalWidth, availableHeight / naturalHeight);
      const displayWidth = Math.round(naturalWidth * scale);
      const displayHeight = Math.round(naturalHeight * scale);

      if (compact) {
        dialog.style.width = `${displayWidth}px`;
        dialog.style.height = `${displayHeight}px`;
      } else {
        dialog.style.removeProperty('width');
        dialog.style.removeProperty('height');
      }

      preview.style.setProperty('width', `${displayWidth}px`, 'important');
      preview.style.setProperty('height', `${displayHeight}px`, 'important');
      preview.style.setProperty('max-width', '100%', 'important');
      preview.style.setProperty('max-height', '100%', 'important');
      preview.style.setProperty('object-fit', 'contain', 'important');
      preview.style.setProperty('object-position', 'center', 'important');
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-jpc-ad-zoom]');
      if (trigger && root.contains(trigger)) {
        const card = trigger.closest('.jpc-ad-image-card, .jpc-ad-detail-card, .jpc-ad-outcome-card');
        const source = card ? card.querySelector('img') : null;
        if (!source) return;

        const naturalWidth = source.naturalWidth || Number(source.getAttribute('width')) || 1200;
        const naturalHeight = source.naturalHeight || Number(source.getAttribute('height')) || 900;
        preview.dataset.naturalWidth = naturalWidth;
        preview.dataset.naturalHeight = naturalHeight;
        preview.width = naturalWidth;
        preview.height = naturalHeight;
        preview.src = source.src || source.currentSrc;
        preview.alt = source.alt || '';
        fitPreviewToViewport();
        if (!dialog.open) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-jpc-ad-lightbox-close]');
      if (closeButton && root.contains(closeButton)) dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      preview.removeAttribute('src');
      preview.alt = '';
      preview.style.removeProperty('width');
      preview.style.removeProperty('height');
      preview.style.removeProperty('max-width');
      preview.style.removeProperty('max-height');
      preview.style.removeProperty('object-fit');
      preview.style.removeProperty('object-position');
      dialog.style.removeProperty('width');
      dialog.style.removeProperty('height');
      delete preview.dataset.naturalWidth;
      delete preview.dataset.naturalHeight;
    });

    window.addEventListener('resize', () => {
      if (dialog.open) fitPreviewToViewport();
    });

    root.dataset.jpcAdLightboxReady = 'true';
  };

  document.querySelectorAll('[data-jpc-ad-flow]').forEach((root) => {
    initializeJoyprotynCompactReviewToggle(root);
    initializeJoyprotynCompactLightbox(root);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-jpc-ad-flow]');
    initializeJoyprotynCompactReviewToggle(root);
    initializeJoyprotynCompactLightbox(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-compact-egg-compare"] && !Shopify.designMode) return;
  try {
    
  const moveJoyprotynCompactEggComparison = (section) => {
    if (!section || section.dataset.jpcEggCompareMoved === 'true') return;

    const flow = document.querySelector('[data-jpc-ad-flow]');
    const target = flow ? flow.querySelector('.jpc-ad-outcomes') : null;
    if (!target) return;

    target.insertAdjacentElement('afterend', section);
    section.dataset.jpcEggCompareMoved = 'true';
  };

  document.querySelectorAll('[data-jpc-egg-compare]').forEach(moveJoyprotynCompactEggComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jpc-egg-compare]');
    if (section) moveJoyprotynCompactEggComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-compact-feather-compare"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynCompactFeatherComparison = (section) => {
    if (!section || section.dataset.jpcFeatherCompareReady === 'true') return;

    const slider = section.querySelector('[data-jpc-feather-slider]');
    const range = section.querySelector('.jpc-ad-feather-range');
    if (!slider || !range) return;

    const updatePosition = () => {
      slider.style.setProperty('--jpc-feather-position', `${range.value}%`);
    };

    range.addEventListener('input', updatePosition);
    updatePosition();
    section.dataset.jpcFeatherCompareReady = 'true';
  };

  const moveJoyprotynCompactFeatherComparison = (section) => {
    if (!section) return;

    const flow = document.querySelector('[data-jpc-ad-flow]');
    const target = flow ? flow.querySelector('.jpc-ad-outcomes') : null;
    if (!target) return;

    if (target.nextElementSibling !== section) {
      target.insertAdjacentElement('afterend', section);
    }
  };

  const prepareJoyprotynCompactFeatherComparison = (section) => {
    initializeJoyprotynCompactFeatherComparison(section);
    moveJoyprotynCompactFeatherComparison(section);
    requestAnimationFrame(() => moveJoyprotynCompactFeatherComparison(section));
    window.setTimeout(() => moveJoyprotynCompactFeatherComparison(section), 160);
  };

  document.querySelectorAll('[data-jpc-feather-compare]').forEach(prepareJoyprotynCompactFeatherComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jpc-feather-compare]');
    if (section) prepareJoyprotynCompactFeatherComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-compact-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var preloadedImages = {};

    function preloadImage(src) {
      if (!src || preloadedImages[src]) return;

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
      preloadedImages[src] = image;
    }

    function initIntroCollapse(root) {
      var scope = root || document;
      var intros = scope.querySelectorAll('[data-collapsible-intro]');

      intros.forEach(function (intro) {
        if (intro.dataset.collapseReady === 'true') return;

        var toggle = intro.querySelector('[data-intro-toggle]');

        if (!toggle) return;

        intro.dataset.collapseReady = 'true';

        toggle.addEventListener('click', function () {
          var expanded = intro.classList.toggle('is-expanded');

          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          toggle.textContent = expanded
            ? toggle.getAttribute('data-collapse-label')
            : toggle.getAttribute('data-expand-label');
        });
      });
    }

    function initGallery(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.jpc-pdp-hero');

      sections.forEach(function (section) {
        if (section.dataset.galleryReady === 'true') return;

        var mainImage = section.querySelector('.jpc-hero-image');
        var thumbs = section.querySelectorAll('[data-gallery-thumb]');

        if (!mainImage || thumbs.length === 0) return;

        section.dataset.galleryReady = 'true';
        mainImage.decoding = 'async';

        thumbs.forEach(function (thumb) {
          preloadImage(thumb.getAttribute('data-gallery-src'));

          thumb.addEventListener('mouseenter', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('focus', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-gallery-src');
            var srcset = thumb.getAttribute('data-gallery-srcset');
            var alt = thumb.getAttribute('data-gallery-alt') || '';

            if (!src) return;

            thumbs.forEach(function (item) {
              item.classList.remove('is-active');
              item.setAttribute('aria-current', 'false');
            });

            thumb.classList.add('is-active');
            thumb.setAttribute('aria-current', 'true');

            if (srcset) {
              mainImage.srcset = srcset;
            } else {
              mainImage.removeAttribute('srcset');
            }

            mainImage.src = src;
            mainImage.alt = alt;
          });
        });
      });
    }

    function initVariantOptions(root) {
      var scope = root || document;
      var forms = scope.querySelectorAll('.jpc-product-form');

      forms.forEach(function (form) {
        if (form.dataset.variantReady === 'true') return;

        var radios = form.querySelectorAll('[data-variant-radio]');
        var variantIdInput = form.querySelector('[data-selected-variant-id]');
        var addButton = form.querySelector('[data-add-to-cart]');
        var checkoutButton = form.querySelector('[data-checkout]');
        var priceTargets = form.querySelectorAll('[data-variant-price-target]');
        var comparePriceTargets = form.querySelectorAll('[data-variant-compare-target]');
        var heroSection = form.closest('.jpc-pdp-hero');
        var mainImage = heroSection ? heroSection.querySelector('.jpc-hero-image') : null;
        var galleryThumbs = heroSection ? heroSection.querySelectorAll('[data-gallery-thumb]') : [];


        if (radios.length === 0) return;

        form.dataset.variantReady = 'true';

        function selectedRadio() {
          var selected = form.querySelector('[data-variant-radio]:checked');
          var requestedVariantId = new URLSearchParams(window.location.search).get('variant');

          if (requestedVariantId) {
            for (var index = 0; index < radios.length; index += 1) {
              var requestedRadio = radios[index];
              var requestedRadioAvailable = requestedRadio.getAttribute('data-variant-available') === 'true';

              if (requestedRadio.value === requestedVariantId && requestedRadioAvailable) {
                requestedRadio.checked = true;
                return requestedRadio;
              }
            }
          }

          return selected || radios[0];
        }

        function syncVariantMedia(radio) {
          if (!radio || !mainImage) return;

          var mediaId = radio.getAttribute('data-variant-media-id') || '';
          var src = radio.getAttribute('data-variant-media-src') || '';
          var srcset = radio.getAttribute('data-variant-media-srcset') || '';
          var alt = radio.getAttribute('data-variant-media-alt') || '';

          if (!src) return;

          if (srcset) {
            mainImage.srcset = srcset;
          } else {
            mainImage.removeAttribute('srcset');
          }

          mainImage.src = src;
          mainImage.alt = alt;

          galleryThumbs.forEach(function (thumb) {
            var isActive = mediaId !== '' && thumb.getAttribute('data-gallery-media-id') === mediaId;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }

        function syncVariant(radio) {
          if (!radio) return;

          var price = radio.getAttribute('data-variant-price') || '';
          var comparePrice = radio.getAttribute('data-variant-compare-price') || '';
          var hasComparePrice = radio.getAttribute('data-variant-has-compare-price') === 'true';
          var available = radio.getAttribute('data-variant-available') === 'true';

          syncVariantMedia(radio);

          priceTargets.forEach(function (target) {
            target.textContent = price;
          });

          comparePriceTargets.forEach(function (target) {
            target.textContent = comparePrice;
            target.hidden = !hasComparePrice;
          });

          if (addButton) {
            if (available) {
              addButton.disabled = false;
              addButton.textContent = addButton.getAttribute('data-add-label') + ' - ' + price;
            } else {
              addButton.disabled = true;
              addButton.textContent = addButton.getAttribute('data-sold-out-label');
            }
          }

          if (checkoutButton) {
            checkoutButton.disabled = !available;
            checkoutButton.textContent = available
              ? checkoutButton.getAttribute('data-checkout-label')
              : checkoutButton.getAttribute('data-sold-out-label');
          }

          if (variantIdInput && variantIdInput.value !== radio.value) {
            variantIdInput.value = radio.value;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            syncVariant(radio);
          });
        });

        syncVariant(selectedRadio());
      });
    }

    function initPurchaseOptions(root) {
      var scope = root || document;
      var groups = scope.querySelectorAll('[data-purchase-options]');

      groups.forEach(function (group) {
        if (group.dataset.purchaseReady === 'true') return;

        var cards = group.querySelectorAll('[data-purchase-mode]');
        var subscribeCard = group.querySelector('[data-purchase-mode="subscription"]');
        var sellingPlanInput = group.querySelector('[data-selling-plan-input]');
        var sellingPlanSelect = group.querySelector('[data-selling-plan-select]');
        var sellingPlanRow = group.querySelector('[data-selling-plan-row]');
        var allocationDataElement = group.querySelector('[data-selling-plan-allocations]');
        var form = group.closest('form');
        var variantIdInput = form ? form.querySelector('[data-selected-variant-id]') : null;
        var addButton = form ? form.querySelector('[data-add-to-cart]') : null;
        var subscriptionConsent = form ? form.querySelector('[data-subscription-consent]') : null;
        var subscriptionPriceTarget = group.querySelector('[data-subscription-price-target]');
        var subscriptionCompareTarget = group.querySelector('[data-subscription-compare-target]');
        var subscriptionSavingsTarget = group.querySelector('[data-subscription-savings-target]');
        var subscriptionPerkTarget = group.querySelector('[data-subscription-perk-target]');
        var allocationMap = {};
        var currentAllocations = [];
        var activeMode = subscribeCard && !subscribeCard.hidden ? 'subscription' : 'onetime';

        if (cards.length === 0) return;

        if (allocationDataElement) {
          try {
            allocationMap = JSON.parse(allocationDataElement.textContent || '{}');
          } catch (error) {
            console.error('Unable to parse selling plan allocations.', error);
          }
        }

        group.dataset.purchaseReady = 'true';

        function syncBuyerConsent(isSubscription) {
          if (!subscriptionConsent) return;

          subscriptionConsent.hidden = !isSubscription;
        }

        function notifySellingPlanChange() {
          if (!sellingPlanInput) return;
          sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        function findAllocation(planId) {
          var requestedId = String(planId || '');

          return currentAllocations.find(function (allocation) {
            return String(allocation.id) === requestedId;
          }) || currentAllocations[0] || null;
        }

        function syncAddButtonPrice(allocation) {
          if (!addButton || !form) return;

          var selectedVariantRadio = form.querySelector('[data-variant-radio]:checked');
          if (!selectedVariantRadio || selectedVariantRadio.getAttribute('data-variant-available') !== 'true') return;

          var displayPrice = selectedVariantRadio.getAttribute('data-variant-price') || '';
          if (activeMode === 'subscription' && allocation && allocation.price) {
            displayPrice = allocation.price;
          }

          addButton.textContent = addButton.getAttribute('data-add-label') + ' - ' + displayPrice;
        }

        function syncAllocationDisplay(allocation) {
          if (!allocation) return;

          var savingsPercent = Number(allocation.savingsPercent) || 0;

          if (subscriptionPriceTarget) {
            subscriptionPriceTarget.textContent = allocation.price || '';
          }

          if (subscriptionCompareTarget) {
            subscriptionCompareTarget.textContent = allocation.comparePrice || '';
            subscriptionCompareTarget.hidden = savingsPercent <= 0;
          }

          if (subscriptionSavingsTarget) {
            subscriptionSavingsTarget.textContent = 'SAVE ' + savingsPercent + '%';
            subscriptionSavingsTarget.hidden = savingsPercent <= 0;
          }

          if (subscriptionPerkTarget) {
            subscriptionPerkTarget.textContent = savingsPercent > 0
              ? 'Save ' + savingsPercent + '% on recurring orders'
              : 'Subscriber pricing on recurring orders';
          }

          if (subscribeCard) {
            subscribeCard.setAttribute('data-selling-plan-id', String(allocation.id));
          }

          if (activeMode === 'subscription') {
            syncAddButtonPrice(allocation);
          }
        }

        function setMode(mode) {
          var selectedSellingPlanId = '';

          if (mode === 'subscription' && currentAllocations.length === 0) {
            mode = 'onetime';
          }

          activeMode = mode;

          cards.forEach(function (card) {
            var isSelected = card.getAttribute('data-purchase-mode') === mode;
            card.classList.toggle('is-selected', isSelected);
            card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

            if (isSelected && mode === 'subscription') {
              selectedSellingPlanId = card.getAttribute('data-selling-plan-id') || '';
            }
          });

          if (!sellingPlanInput) return;

          if (mode === 'subscription') {
            if (sellingPlanSelect && sellingPlanSelect.value) {
              selectedSellingPlanId = sellingPlanSelect.value;
            }

            var selectedAllocation = findAllocation(selectedSellingPlanId);
            if (selectedAllocation) {
              selectedSellingPlanId = String(selectedAllocation.id);
              if (sellingPlanSelect) {
                sellingPlanSelect.value = selectedSellingPlanId;
              }
              syncAllocationDisplay(selectedAllocation);
            }

            sellingPlanInput.disabled = false;
            sellingPlanInput.value = selectedSellingPlanId;

            if (sellingPlanSelect) {
              sellingPlanSelect.disabled = false;
            }

            if (sellingPlanRow) {
              sellingPlanRow.hidden = false;
            }
          } else {
            sellingPlanInput.value = '';
            sellingPlanInput.disabled = true;

            if (sellingPlanSelect) {
              sellingPlanSelect.disabled = true;
            }

            if (sellingPlanRow) {
              sellingPlanRow.hidden = true;
            }
          }

          syncAddButtonPrice(mode === 'subscription' ? findAllocation(selectedSellingPlanId) : null);
          notifySellingPlanChange();
          syncBuyerConsent(mode === 'subscription');
        }

        function rebuildSellingPlans(variantId) {
          var previousPlanId = sellingPlanSelect ? sellingPlanSelect.value : '';
          currentAllocations = allocationMap[String(variantId || '')] || [];

          if (subscribeCard) {
            subscribeCard.hidden = currentAllocations.length === 0;
          }

          if (sellingPlanSelect) {
            sellingPlanSelect.textContent = '';

            currentAllocations.forEach(function (allocation) {
              var option = document.createElement('option');
              option.value = String(allocation.id);
              option.textContent = allocation.label || '';
              sellingPlanSelect.appendChild(option);
            });

            var selectedAllocation = findAllocation(previousPlanId);
            if (selectedAllocation) {
              sellingPlanSelect.value = String(selectedAllocation.id);
              syncAllocationDisplay(selectedAllocation);
            }
          }

          setMode(activeMode);
        }

        cards.forEach(function (card) {
          card.addEventListener('click', function () {
            setMode(card.getAttribute('data-purchase-mode'));
          });

          card.addEventListener('keydown', function (event) {
            if (event.target !== card) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;

            event.preventDefault();
            setMode(card.getAttribute('data-purchase-mode'));
          });
        });

        if (sellingPlanSelect) {
          sellingPlanSelect.addEventListener('change', function () {
            var selectedAllocation = findAllocation(sellingPlanSelect.value);
            if (selectedAllocation) {
              syncAllocationDisplay(selectedAllocation);
            }

            if (sellingPlanInput && !sellingPlanInput.disabled) {
              sellingPlanInput.value = sellingPlanSelect.value;
              notifySellingPlanChange();
              syncBuyerConsent(true);
            }
          });
        }

        if (variantIdInput) {
          variantIdInput.addEventListener('change', function () {
            rebuildSellingPlans(variantIdInput.value);
          });
        }

        rebuildSellingPlans(variantIdInput ? variantIdInput.value : '');
      });
    }

    function init(root) {
      initIntroCollapse(root);
      initGallery(root);
      initVariantOptions(root);
      initPurchaseOptions(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-editorial-ad-content"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynEditorialReviewToggle = (root) => {
    if (!root || root.dataset.jpeAdReviewToggleReady === 'true') return;

    const quotes = root.querySelector('.jpe-ad-review-quotes');
    const toggle = root.querySelector('[data-jpe-review-toggle]');
    const label = toggle ? toggle.querySelector('[data-jpe-review-toggle-label]') : null;
    if (!quotes || !toggle || !label) return;

    toggle.addEventListener('click', () => {
      const expanded = quotes.dataset.expanded !== 'true';
      quotes.dataset.expanded = String(expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? 'fewer reviews' : 'more reviews';
    });

    root.dataset.jpeAdReviewToggleReady = 'true';
  };

  const initializeJoyprotynEditorialLightbox = (root) => {
    if (!root || root.dataset.jpeAdLightboxReady === 'true') return;

    const dialog = root.querySelector('[data-jpe-ad-lightbox]');
    const frame = root.querySelector('.jpe-ad-lightbox-inner');
    const preview = root.querySelector('[data-jpe-ad-lightbox-image]');
    if (!dialog || !frame || !preview) return;

    const fitPreviewToViewport = () => {
      const naturalWidth = Number(preview.dataset.naturalWidth);
      const naturalHeight = Number(preview.dataset.naturalHeight);
      if (!naturalWidth || !naturalHeight) return;

      const compact = window.matchMedia('(max-width: 720px)').matches;
      const availableWidth = compact
        ? Math.max(220, window.innerWidth - 20)
        : Math.max(220, Math.min(1480, window.innerWidth - 32));
      const availableHeight = compact
        ? Math.max(220, window.innerHeight - 20)
        : Math.max(220, window.innerHeight - 32);
      const scale = Math.min(availableWidth / naturalWidth, availableHeight / naturalHeight);
      const displayWidth = Math.round(naturalWidth * scale);
      const displayHeight = Math.round(naturalHeight * scale);

      if (compact) {
        dialog.style.width = `${displayWidth}px`;
        dialog.style.height = `${displayHeight}px`;
      } else {
        dialog.style.removeProperty('width');
        dialog.style.removeProperty('height');
      }

      preview.style.setProperty('width', `${displayWidth}px`, 'important');
      preview.style.setProperty('height', `${displayHeight}px`, 'important');
      preview.style.setProperty('max-width', '100%', 'important');
      preview.style.setProperty('max-height', '100%', 'important');
      preview.style.setProperty('object-fit', 'contain', 'important');
      preview.style.setProperty('object-position', 'center', 'important');
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-jpe-ad-zoom]');
      if (trigger && root.contains(trigger)) {
        const card = trigger.closest('.jpe-ad-image-card, .jpe-ad-detail-card, .jpe-ad-outcome-card');
        const source = card ? card.querySelector('img') : null;
        if (!source) return;

        const naturalWidth = source.naturalWidth || Number(source.getAttribute('width')) || 1200;
        const naturalHeight = source.naturalHeight || Number(source.getAttribute('height')) || 900;
        preview.dataset.naturalWidth = naturalWidth;
        preview.dataset.naturalHeight = naturalHeight;
        preview.width = naturalWidth;
        preview.height = naturalHeight;
        preview.src = source.src || source.currentSrc;
        preview.alt = source.alt || '';
        fitPreviewToViewport();
        if (!dialog.open) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-jpe-ad-lightbox-close]');
      if (closeButton && root.contains(closeButton)) dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      preview.removeAttribute('src');
      preview.alt = '';
      preview.style.removeProperty('width');
      preview.style.removeProperty('height');
      preview.style.removeProperty('max-width');
      preview.style.removeProperty('max-height');
      preview.style.removeProperty('object-fit');
      preview.style.removeProperty('object-position');
      dialog.style.removeProperty('width');
      dialog.style.removeProperty('height');
      delete preview.dataset.naturalWidth;
      delete preview.dataset.naturalHeight;
    });

    window.addEventListener('resize', () => {
      if (dialog.open) fitPreviewToViewport();
    });

    root.dataset.jpeAdLightboxReady = 'true';
  };

  document.querySelectorAll('[data-jpe-ad-flow]').forEach((root) => {
    initializeJoyprotynEditorialReviewToggle(root);
    initializeJoyprotynEditorialLightbox(root);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-jpe-ad-flow]');
    initializeJoyprotynEditorialReviewToggle(root);
    initializeJoyprotynEditorialLightbox(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-editorial-egg-compare"] && !Shopify.designMode) return;
  try {
    
  const moveJoyprotynEditorialEggComparison = (section) => {
    if (!section || section.dataset.jpeEggCompareMoved === 'true') return;

    const flow = document.querySelector('[data-jpe-ad-flow]');
    const target = flow ? flow.querySelector('.jpe-ad-outcomes') : null;
    if (!target) return;

    target.insertAdjacentElement('afterend', section);
    section.dataset.jpeEggCompareMoved = 'true';
  };

  document.querySelectorAll('[data-jpe-egg-compare]').forEach(moveJoyprotynEditorialEggComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jpe-egg-compare]');
    if (section) moveJoyprotynEditorialEggComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-editorial-feather-compare"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynEditorialFeatherComparison = (section) => {
    if (!section || section.dataset.jpeFeatherCompareReady === 'true') return;

    const slider = section.querySelector('[data-jpe-feather-slider]');
    const range = section.querySelector('.jpe-ad-feather-range');
    if (!slider || !range) return;

    const updatePosition = () => {
      slider.style.setProperty('--jpe-feather-position', `${range.value}%`);
    };

    range.addEventListener('input', updatePosition);
    updatePosition();
    section.dataset.jpeFeatherCompareReady = 'true';
  };

  const moveJoyprotynEditorialFeatherComparison = (section) => {
    if (!section) return;

    const flow = document.querySelector('[data-jpe-ad-flow]');
    const target = flow ? flow.querySelector('.jpe-ad-outcomes') : null;
    if (!target) return;

    if (target.nextElementSibling !== section) {
      target.insertAdjacentElement('afterend', section);
    }
  };

  const prepareJoyprotynEditorialFeatherComparison = (section) => {
    initializeJoyprotynEditorialFeatherComparison(section);
    moveJoyprotynEditorialFeatherComparison(section);
    requestAnimationFrame(() => moveJoyprotynEditorialFeatherComparison(section));
    window.setTimeout(() => moveJoyprotynEditorialFeatherComparison(section), 160);
  };

  document.querySelectorAll('[data-jpe-feather-compare]').forEach(prepareJoyprotynEditorialFeatherComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jpe-feather-compare]');
    if (section) prepareJoyprotynEditorialFeatherComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-editorial-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var preloadedImages = {};

    function preloadImage(src) {
      if (!src || preloadedImages[src]) return;

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
      preloadedImages[src] = image;
    }

    function initIntroCollapse(root) {
      var scope = root || document;
      var intros = scope.querySelectorAll('[data-collapsible-intro]');

      intros.forEach(function (intro) {
        if (intro.dataset.collapseReady === 'true') return;

        var toggle = intro.querySelector('[data-intro-toggle]');

        if (!toggle) return;

        intro.dataset.collapseReady = 'true';

        toggle.addEventListener('click', function () {
          var expanded = intro.classList.toggle('is-expanded');

          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          toggle.textContent = expanded
            ? toggle.getAttribute('data-collapse-label')
            : toggle.getAttribute('data-expand-label');
        });
      });
    }

    function initGallery(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.jpe-pdp-hero');

      sections.forEach(function (section) {
        if (section.dataset.galleryReady === 'true') return;

        var mainImage = section.querySelector('.jpe-hero-image');
        var thumbs = section.querySelectorAll('[data-gallery-thumb]');

        if (!mainImage || thumbs.length === 0) return;

        section.dataset.galleryReady = 'true';
        mainImage.decoding = 'async';

        thumbs.forEach(function (thumb) {
          preloadImage(thumb.getAttribute('data-gallery-src'));

          thumb.addEventListener('mouseenter', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('focus', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-gallery-src');
            var srcset = thumb.getAttribute('data-gallery-srcset');
            var alt = thumb.getAttribute('data-gallery-alt') || '';

            if (!src) return;

            thumbs.forEach(function (item) {
              item.classList.remove('is-active');
              item.setAttribute('aria-current', 'false');
            });

            thumb.classList.add('is-active');
            thumb.setAttribute('aria-current', 'true');

            if (srcset) {
              mainImage.srcset = srcset;
            } else {
              mainImage.removeAttribute('srcset');
            }

            mainImage.src = src;
            mainImage.alt = alt;
          });
        });
      });
    }

    function initVariantOptions(root) {
      var scope = root || document;
      var forms = scope.querySelectorAll('.jpe-product-form');

      forms.forEach(function (form) {
        if (form.dataset.variantReady === 'true') return;

        var radios = form.querySelectorAll('[data-variant-radio]');
        var variantIdInput = form.querySelector('[data-selected-variant-id]');
        var addButton = form.querySelector('[data-add-to-cart]');
        var checkoutButton = form.querySelector('[data-checkout]');
        var priceTargets = form.querySelectorAll('[data-variant-price-target]');
        var subscriptionPriceTargets = form.querySelectorAll('[data-subscription-price-target]');
        var subscriptionCompareTargets = form.querySelectorAll('[data-subscription-compare-target]');
        var heroSection = form.closest('.jpe-pdp-hero');
        var mainImage = heroSection ? heroSection.querySelector('.jpe-hero-image') : null;
        var galleryThumbs = heroSection ? heroSection.querySelectorAll('[data-gallery-thumb]') : [];


        if (radios.length === 0) return;

        form.dataset.variantReady = 'true';

        function selectedRadio() {
          var selected = form.querySelector('[data-variant-radio]:checked');
          return selected || radios[0];
        }

        function syncVariantMedia(radio) {
          if (!radio || !mainImage) return;

          var mediaId = radio.getAttribute('data-variant-media-id') || '';
          var src = radio.getAttribute('data-variant-media-src') || '';
          var srcset = radio.getAttribute('data-variant-media-srcset') || '';
          var alt = radio.getAttribute('data-variant-media-alt') || '';

          if (!src) return;

          if (srcset) {
            mainImage.srcset = srcset;
          } else {
            mainImage.removeAttribute('srcset');
          }

          mainImage.src = src;
          mainImage.alt = alt;

          galleryThumbs.forEach(function (thumb) {
            var isActive = mediaId !== '' && thumb.getAttribute('data-gallery-media-id') === mediaId;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }

        function syncVariant(radio) {
          if (!radio) return;

          var price = radio.getAttribute('data-variant-price') || '';
          var subscriptionPrice = radio.getAttribute('data-variant-subscription-price') || price;
          var available = radio.getAttribute('data-variant-available') === 'true';

          syncVariantMedia(radio);

          if (variantIdInput && variantIdInput.value !== radio.value) {
            variantIdInput.value = radio.value;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          priceTargets.forEach(function (target) {
            target.textContent = price;
          });

          subscriptionPriceTargets.forEach(function (target) {
            target.textContent = subscriptionPrice;
          });

          subscriptionCompareTargets.forEach(function (target) {
            target.textContent = price;
          });

          if (addButton) {
            if (available) {
              addButton.disabled = false;
              addButton.textContent = addButton.getAttribute('data-add-label') + ' - ' + price;
            } else {
              addButton.disabled = true;
              addButton.textContent = addButton.getAttribute('data-sold-out-label');
            }
          }

          if (checkoutButton) {
            checkoutButton.disabled = !available;
            checkoutButton.textContent = available
              ? checkoutButton.getAttribute('data-checkout-label')
              : checkoutButton.getAttribute('data-sold-out-label');
          }
        }

        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            syncVariant(radio);
          });
        });

        syncVariant(selectedRadio());
      });
    }

    function initPurchaseOptions(root) {
      var scope = root || document;
      var groups = scope.querySelectorAll('[data-purchase-options]');

      groups.forEach(function (group) {
        if (group.dataset.purchaseReady === 'true') return;

        var cards = group.querySelectorAll('[data-purchase-mode]');
        var sellingPlanInput = group.querySelector('[data-selling-plan-input]');
        var sellingPlanSelect = group.querySelector('[data-selling-plan-select]');
        var sellingPlanRow = group.querySelector('[data-selling-plan-row]');
        var form = group.closest('form');
        var subscriptionConsent = form ? form.querySelector('[data-subscription-consent]') : null;

        if (cards.length === 0) return;

        group.dataset.purchaseReady = 'true';

        function syncBuyerConsent(isSubscription) {
          if (!subscriptionConsent) return;

          subscriptionConsent.hidden = !isSubscription;
        }

        function notifySellingPlanChange() {
          sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        function setMode(mode) {
          var selectedSellingPlanId = '';

          cards.forEach(function (card) {
            var isSelected = card.getAttribute('data-purchase-mode') === mode;
            card.classList.toggle('is-selected', isSelected);
            card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

            if (isSelected && mode === 'subscription') {
              selectedSellingPlanId = card.getAttribute('data-selling-plan-id') || '';
            }
          });

          if (!sellingPlanInput) return;

          if (mode === 'subscription') {
            if (sellingPlanSelect && sellingPlanSelect.value) {
              selectedSellingPlanId = sellingPlanSelect.value;
            }

            sellingPlanInput.disabled = false;
            sellingPlanInput.value = selectedSellingPlanId;

            if (sellingPlanSelect) {
              sellingPlanSelect.disabled = false;
            }

            if (sellingPlanRow) {
              sellingPlanRow.hidden = false;
            }
          } else {
            sellingPlanInput.value = '';
            sellingPlanInput.disabled = true;

            if (sellingPlanSelect) {
              sellingPlanSelect.disabled = true;
            }

            if (sellingPlanRow) {
              sellingPlanRow.hidden = true;
            }
          }

          notifySellingPlanChange();
          syncBuyerConsent(mode === 'subscription');
        }

        cards.forEach(function (card) {
          card.addEventListener('click', function () {
            setMode(card.getAttribute('data-purchase-mode'));
          });

          card.addEventListener('keydown', function (event) {
            if (event.target !== card) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;

            event.preventDefault();
            setMode(card.getAttribute('data-purchase-mode'));
          });
        });

        if (sellingPlanSelect) {
          sellingPlanSelect.addEventListener('change', function () {
            if (sellingPlanInput && !sellingPlanInput.disabled) {
              sellingPlanInput.value = sellingPlanSelect.value;
              notifySellingPlanChange();
              syncBuyerConsent(true);
            }
          });
        }

        setMode('onetime');
      });
    }

    function init(root) {
      initIntroCollapse(root);
      initGallery(root);
      initVariantOptions(root);
      initPurchaseOptions(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-metaobject-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var preloadedImages = {};

    function preloadImage(src) {
      if (!src || preloadedImages[src]) return;

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
      preloadedImages[src] = image;
    }

    function initIntroCollapse(root) {
      var scope = root || document;
      var intros = scope.querySelectorAll('[data-collapsible-intro]');

      intros.forEach(function (intro) {
        if (intro.dataset.collapseReady === 'true') return;

        var toggle = intro.querySelector('[data-intro-toggle]');

        if (!toggle) return;

        intro.dataset.collapseReady = 'true';

        toggle.addEventListener('click', function () {
          var expanded = intro.classList.toggle('is-expanded');

          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          toggle.textContent = expanded
            ? toggle.getAttribute('data-collapse-label')
            : toggle.getAttribute('data-expand-label');
        });
      });
    }

    function initGallery(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.jp-pdp-hero');

      sections.forEach(function (section) {
        if (section.dataset.galleryReady === 'true') return;

        var mainImage = section.querySelector('.jp-hero-image');
        var thumbs = section.querySelectorAll('[data-gallery-thumb]');

        if (!mainImage || thumbs.length === 0) return;

        section.dataset.galleryReady = 'true';
        mainImage.decoding = 'async';

        thumbs.forEach(function (thumb) {
          preloadImage(thumb.getAttribute('data-gallery-src'));

          thumb.addEventListener('mouseenter', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('focus', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-gallery-src');
            var srcset = thumb.getAttribute('data-gallery-srcset');
            var alt = thumb.getAttribute('data-gallery-alt') || '';

            if (!src) return;

            thumbs.forEach(function (item) {
              item.classList.remove('is-active');
              item.setAttribute('aria-current', 'false');
            });

            thumb.classList.add('is-active');
            thumb.setAttribute('aria-current', 'true');

            if (srcset) {
              mainImage.srcset = srcset;
            } else {
              mainImage.removeAttribute('srcset');
            }

            mainImage.src = src;
            mainImage.alt = alt;
          });
        });
      });
    }

    function initVariantOptions(root) {
      var scope = root || document;
      var forms = scope.querySelectorAll('.jp-product-form');

      forms.forEach(function (form) {
        if (form.dataset.variantReady === 'true') return;

        var radios = form.querySelectorAll('[data-variant-radio]');
        var variantIdInput = form.querySelector('[data-selected-variant-id]');
        var addButton = form.querySelector('[data-add-to-cart]');
        var checkoutButton = form.querySelector('[data-checkout]');
        var priceTargets = form.querySelectorAll('[data-variant-price-target]');
        var subscriptionPriceTargets = form.querySelectorAll('[data-subscription-price-target]');
        var subscriptionCompareTargets = form.querySelectorAll('[data-subscription-compare-target]');
        var heroSection = form.closest('.jp-pdp-hero');
        var mainImage = heroSection ? heroSection.querySelector('.jp-hero-image') : null;
        var galleryThumbs = heroSection ? heroSection.querySelectorAll('[data-gallery-thumb]') : [];


        if (radios.length === 0) return;

        form.dataset.variantReady = 'true';

        function selectedRadio() {
          var selected = form.querySelector('[data-variant-radio]:checked');
          return selected || radios[0];
        }

        function syncVariantMedia(radio) {
          if (!radio || !mainImage) return;

          var mediaId = radio.getAttribute('data-variant-media-id') || '';
          var src = radio.getAttribute('data-variant-media-src') || '';
          var srcset = radio.getAttribute('data-variant-media-srcset') || '';
          var alt = radio.getAttribute('data-variant-media-alt') || '';

          if (!src) return;

          if (srcset) {
            mainImage.srcset = srcset;
          } else {
            mainImage.removeAttribute('srcset');
          }

          mainImage.src = src;
          mainImage.alt = alt;

          galleryThumbs.forEach(function (thumb) {
            var isActive = mediaId !== '' && thumb.getAttribute('data-gallery-media-id') === mediaId;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }

        function syncVariant(radio) {
          if (!radio) return;

          var price = radio.getAttribute('data-variant-price') || '';
          var subscriptionPrice = radio.getAttribute('data-variant-subscription-price') || price;
          var available = radio.getAttribute('data-variant-available') === 'true';

          syncVariantMedia(radio);

          if (variantIdInput && variantIdInput.value !== radio.value) {
            variantIdInput.value = radio.value;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          priceTargets.forEach(function (target) {
            target.textContent = price;
          });

          subscriptionPriceTargets.forEach(function (target) {
            target.textContent = subscriptionPrice;
          });

          subscriptionCompareTargets.forEach(function (target) {
            target.textContent = price;
          });

          if (addButton) {
            if (available) {
              addButton.disabled = false;
              addButton.textContent = addButton.getAttribute('data-add-label') + ' - ' + price;
            } else {
              addButton.disabled = true;
              addButton.textContent = addButton.getAttribute('data-sold-out-label');
            }
          }

          if (checkoutButton) {
            checkoutButton.disabled = !available;
            checkoutButton.textContent = available
              ? checkoutButton.getAttribute('data-checkout-label')
              : checkoutButton.getAttribute('data-sold-out-label');
          }
        }

        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            syncVariant(radio);
          });
        });

        syncVariant(selectedRadio());
      });
    }

    function initPurchaseOptions(root) {
      var scope = root || document;
      var groups = scope.querySelectorAll('[data-purchase-options]');

      groups.forEach(function (group) {
        if (group.dataset.purchaseReady === 'true') return;

        var cards = group.querySelectorAll('[data-purchase-mode]');
        var sellingPlanInput = group.querySelector('[data-selling-plan-input]');
        var sellingPlanSelect = group.querySelector('[data-selling-plan-select]');
        var sellingPlanRow = group.querySelector('[data-selling-plan-row]');
        var form = group.closest('form');
        var subscriptionConsent = form ? form.querySelector('[data-subscription-consent]') : null;

        if (cards.length === 0) return;

        group.dataset.purchaseReady = 'true';

        function syncBuyerConsent(isSubscription) {
          if (!subscriptionConsent) return;

          subscriptionConsent.hidden = !isSubscription;
        }

        function notifySellingPlanChange() {
          sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        function setMode(mode) {
          var selectedSellingPlanId = '';

          cards.forEach(function (card) {
            var isSelected = card.getAttribute('data-purchase-mode') === mode;
            card.classList.toggle('is-selected', isSelected);
            card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

            if (isSelected && mode === 'subscription') {
              selectedSellingPlanId = card.getAttribute('data-selling-plan-id') || '';
            }
          });

          if (!sellingPlanInput) return;

          if (mode === 'subscription') {
            if (sellingPlanSelect && sellingPlanSelect.value) {
              selectedSellingPlanId = sellingPlanSelect.value;
            }

            sellingPlanInput.disabled = false;
            sellingPlanInput.value = selectedSellingPlanId;

            if (sellingPlanSelect) {
              sellingPlanSelect.disabled = false;
            }

            if (sellingPlanRow) {
              sellingPlanRow.hidden = false;
            }
          } else {
            sellingPlanInput.value = '';
            sellingPlanInput.disabled = true;

            if (sellingPlanSelect) {
              sellingPlanSelect.disabled = true;
            }

            if (sellingPlanRow) {
              sellingPlanRow.hidden = true;
            }
          }

          notifySellingPlanChange();
          syncBuyerConsent(mode === 'subscription');
        }

        cards.forEach(function (card) {
          card.addEventListener('click', function () {
            setMode(card.getAttribute('data-purchase-mode'));
          });

          card.addEventListener('keydown', function (event) {
            if (event.target !== card) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;

            event.preventDefault();
            setMode(card.getAttribute('data-purchase-mode'));
          });
        });

        if (sellingPlanSelect) {
          sellingPlanSelect.addEventListener('change', function () {
            if (sellingPlanInput && !sellingPlanInput.disabled) {
              sellingPlanInput.value = sellingPlanSelect.value;
              notifySellingPlanChange();
              syncBuyerConsent(true);
            }
          });
        }

        setMode('onetime');
      });
    }

    function init(root) {
      initIntroCollapse(root);
      initGallery(root);
      initVariantOptions(root);
      initPurchaseOptions(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-modern-ad-content"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynModernReviewToggle = (root) => {
    if (!root || root.dataset.jpmAdReviewToggleReady === 'true') return;

    const quotes = root.querySelector('.jpm-ad-review-quotes');
    const toggle = root.querySelector('[data-jpm-review-toggle]');
    const label = toggle ? toggle.querySelector('[data-jpm-review-toggle-label]') : null;
    if (!quotes || !toggle || !label) return;

    toggle.addEventListener('click', () => {
      const expanded = quotes.dataset.expanded !== 'true';
      quotes.dataset.expanded = String(expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? 'fewer reviews' : 'more reviews';
    });

    root.dataset.jpmAdReviewToggleReady = 'true';
  };

  const initializeJoyprotynModernLightbox = (root) => {
    if (!root || root.dataset.jpmAdLightboxReady === 'true') return;

    const dialog = root.querySelector('[data-jpm-ad-lightbox]');
    const frame = root.querySelector('.jpm-ad-lightbox-inner');
    const preview = root.querySelector('[data-jpm-ad-lightbox-image]');
    if (!dialog || !frame || !preview) return;

    const fitPreviewToViewport = () => {
      const naturalWidth = Number(preview.dataset.naturalWidth);
      const naturalHeight = Number(preview.dataset.naturalHeight);
      if (!naturalWidth || !naturalHeight) return;

      const compact = window.matchMedia('(max-width: 720px)').matches;
      const availableWidth = compact
        ? Math.max(220, window.innerWidth - 20)
        : Math.max(220, Math.min(1480, window.innerWidth - 32));
      const availableHeight = compact
        ? Math.max(220, window.innerHeight - 20)
        : Math.max(220, window.innerHeight - 32);
      const scale = Math.min(availableWidth / naturalWidth, availableHeight / naturalHeight);
      const displayWidth = Math.round(naturalWidth * scale);
      const displayHeight = Math.round(naturalHeight * scale);

      if (compact) {
        dialog.style.width = `${displayWidth}px`;
        dialog.style.height = `${displayHeight}px`;
      } else {
        dialog.style.removeProperty('width');
        dialog.style.removeProperty('height');
      }

      preview.style.setProperty('width', `${displayWidth}px`, 'important');
      preview.style.setProperty('height', `${displayHeight}px`, 'important');
      preview.style.setProperty('max-width', '100%', 'important');
      preview.style.setProperty('max-height', '100%', 'important');
      preview.style.setProperty('object-fit', 'contain', 'important');
      preview.style.setProperty('object-position', 'center', 'important');
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-jpm-ad-zoom]');
      if (trigger && root.contains(trigger)) {
        const card = trigger.closest('.jpm-ad-image-card, .jpm-ad-detail-card, .jpm-ad-outcome-card');
        const source = card ? card.querySelector('img') : null;
        if (!source) return;

        const naturalWidth = source.naturalWidth || Number(source.getAttribute('width')) || 1200;
        const naturalHeight = source.naturalHeight || Number(source.getAttribute('height')) || 900;
        preview.dataset.naturalWidth = naturalWidth;
        preview.dataset.naturalHeight = naturalHeight;
        preview.width = naturalWidth;
        preview.height = naturalHeight;
        preview.src = source.src || source.currentSrc;
        preview.alt = source.alt || '';
        fitPreviewToViewport();
        if (!dialog.open) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-jpm-ad-lightbox-close]');
      if (closeButton && root.contains(closeButton)) dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      preview.removeAttribute('src');
      preview.alt = '';
      preview.style.removeProperty('width');
      preview.style.removeProperty('height');
      preview.style.removeProperty('max-width');
      preview.style.removeProperty('max-height');
      preview.style.removeProperty('object-fit');
      preview.style.removeProperty('object-position');
      dialog.style.removeProperty('width');
      dialog.style.removeProperty('height');
      delete preview.dataset.naturalWidth;
      delete preview.dataset.naturalHeight;
    });

    window.addEventListener('resize', () => {
      if (dialog.open) fitPreviewToViewport();
    });

    root.dataset.jpmAdLightboxReady = 'true';
  };

  document.querySelectorAll('[data-jpm-ad-flow]').forEach((root) => {
    initializeJoyprotynModernReviewToggle(root);
    initializeJoyprotynModernLightbox(root);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-jpm-ad-flow]');
    initializeJoyprotynModernReviewToggle(root);
    initializeJoyprotynModernLightbox(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-modern-egg-compare"] && !Shopify.designMode) return;
  try {
    
  const moveJoyprotynModernEggComparison = (section) => {
    if (!section || section.dataset.jpmEggCompareMoved === 'true') return;

    const flow = document.querySelector('[data-jpm-ad-flow]');
    const target = flow ? flow.querySelector('.jpm-ad-outcomes') : null;
    if (!target) return;

    target.insertAdjacentElement('afterend', section);
    section.dataset.jpmEggCompareMoved = 'true';
  };

  document.querySelectorAll('[data-jpm-egg-compare]').forEach(moveJoyprotynModernEggComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jpm-egg-compare]');
    if (section) moveJoyprotynModernEggComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-modern-feather-compare"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynModernFeatherComparison = (section) => {
    if (!section || section.dataset.jpmFeatherCompareReady === 'true') return;

    const slider = section.querySelector('[data-jpm-feather-slider]');
    const range = section.querySelector('.jpm-ad-feather-range');
    if (!slider || !range) return;

    const updatePosition = () => {
      slider.style.setProperty('--jpm-feather-position', `${range.value}%`);
    };

    range.addEventListener('input', updatePosition);
    updatePosition();
    section.dataset.jpmFeatherCompareReady = 'true';
  };

  const moveJoyprotynModernFeatherComparison = (section) => {
    if (!section) return;

    const flow = document.querySelector('[data-jpm-ad-flow]');
    const target = flow ? flow.querySelector('.jpm-ad-outcomes') : null;
    if (!target) return;

    if (target.nextElementSibling !== section) {
      target.insertAdjacentElement('afterend', section);
    }
  };

  const prepareJoyprotynModernFeatherComparison = (section) => {
    initializeJoyprotynModernFeatherComparison(section);
    moveJoyprotynModernFeatherComparison(section);
    requestAnimationFrame(() => moveJoyprotynModernFeatherComparison(section));
    window.setTimeout(() => moveJoyprotynModernFeatherComparison(section), 160);
  };

  document.querySelectorAll('[data-jpm-feather-compare]').forEach(prepareJoyprotynModernFeatherComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jpm-feather-compare]');
    if (section) prepareJoyprotynModernFeatherComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-modern-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var preloadedImages = {};

    function preloadImage(src) {
      if (!src || preloadedImages[src]) return;

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
      preloadedImages[src] = image;
    }

    function initIntroCollapse(root) {
      var scope = root || document;
      var intros = scope.querySelectorAll('[data-collapsible-intro]');

      intros.forEach(function (intro) {
        if (intro.dataset.collapseReady === 'true') return;

        var toggle = intro.querySelector('[data-intro-toggle]');

        if (!toggle) return;

        intro.dataset.collapseReady = 'true';

        toggle.addEventListener('click', function () {
          var expanded = intro.classList.toggle('is-expanded');

          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          toggle.textContent = expanded
            ? toggle.getAttribute('data-collapse-label')
            : toggle.getAttribute('data-expand-label');
        });
      });
    }

    function initGallery(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.jpm-pdp-hero');

      sections.forEach(function (section) {
        if (section.dataset.galleryReady === 'true') return;

        var mainImage = section.querySelector('.jpm-hero-image');
        var thumbs = section.querySelectorAll('[data-gallery-thumb]');

        if (!mainImage || thumbs.length === 0) return;

        section.dataset.galleryReady = 'true';
        mainImage.decoding = 'async';

        thumbs.forEach(function (thumb) {
          preloadImage(thumb.getAttribute('data-gallery-src'));

          thumb.addEventListener('mouseenter', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('focus', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-gallery-src');
            var srcset = thumb.getAttribute('data-gallery-srcset');
            var alt = thumb.getAttribute('data-gallery-alt') || '';

            if (!src) return;

            thumbs.forEach(function (item) {
              item.classList.remove('is-active');
              item.setAttribute('aria-current', 'false');
            });

            thumb.classList.add('is-active');
            thumb.setAttribute('aria-current', 'true');

            if (srcset) {
              mainImage.srcset = srcset;
            } else {
              mainImage.removeAttribute('srcset');
            }

            mainImage.src = src;
            mainImage.alt = alt;
          });
        });
      });
    }

    function initVariantOptions(root) {
      var scope = root || document;
      var forms = scope.querySelectorAll('.jpm-product-form');

      forms.forEach(function (form) {
        if (form.dataset.variantReady === 'true') return;

        var radios = form.querySelectorAll('[data-variant-radio]');
        var variantIdInput = form.querySelector('[data-selected-variant-id]');
        var addButton = form.querySelector('[data-add-to-cart]');
        var checkoutButton = form.querySelector('[data-checkout]');
        var priceTargets = form.querySelectorAll('[data-variant-price-target]');
        var subscriptionPriceTargets = form.querySelectorAll('[data-subscription-price-target]');
        var subscriptionCompareTargets = form.querySelectorAll('[data-subscription-compare-target]');
        var heroSection = form.closest('.jpm-pdp-hero');
        var mainImage = heroSection ? heroSection.querySelector('.jpm-hero-image') : null;
        var galleryThumbs = heroSection ? heroSection.querySelectorAll('[data-gallery-thumb]') : [];


        if (radios.length === 0) return;

        form.dataset.variantReady = 'true';

        function selectedRadio() {
          var selected = form.querySelector('[data-variant-radio]:checked');
          return selected || radios[0];
        }

        function syncVariantMedia(radio) {
          if (!radio || !mainImage) return;

          var mediaId = radio.getAttribute('data-variant-media-id') || '';
          var src = radio.getAttribute('data-variant-media-src') || '';
          var srcset = radio.getAttribute('data-variant-media-srcset') || '';
          var alt = radio.getAttribute('data-variant-media-alt') || '';

          if (!src) return;

          if (srcset) {
            mainImage.srcset = srcset;
          } else {
            mainImage.removeAttribute('srcset');
          }

          mainImage.src = src;
          mainImage.alt = alt;

          galleryThumbs.forEach(function (thumb) {
            var isActive = mediaId !== '' && thumb.getAttribute('data-gallery-media-id') === mediaId;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }

        function syncVariant(radio) {
          if (!radio) return;

          var price = radio.getAttribute('data-variant-price') || '';
          var subscriptionPrice = radio.getAttribute('data-variant-subscription-price') || price;
          var available = radio.getAttribute('data-variant-available') === 'true';

          syncVariantMedia(radio);

          if (variantIdInput && variantIdInput.value !== radio.value) {
            variantIdInput.value = radio.value;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          priceTargets.forEach(function (target) {
            target.textContent = price;
          });

          subscriptionPriceTargets.forEach(function (target) {
            target.textContent = subscriptionPrice;
          });

          subscriptionCompareTargets.forEach(function (target) {
            target.textContent = price;
          });

          if (addButton) {
            if (available) {
              addButton.disabled = false;
              addButton.textContent = addButton.getAttribute('data-add-label') + ' - ' + price;
            } else {
              addButton.disabled = true;
              addButton.textContent = addButton.getAttribute('data-sold-out-label');
            }
          }

          if (checkoutButton) {
            checkoutButton.disabled = !available;
            checkoutButton.textContent = available
              ? checkoutButton.getAttribute('data-checkout-label')
              : checkoutButton.getAttribute('data-sold-out-label');
          }
        }

        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            syncVariant(radio);
          });
        });

        syncVariant(selectedRadio());
      });
    }

    function initPurchaseOptions(root) {
      var scope = root || document;
      var groups = scope.querySelectorAll('[data-purchase-options]');

      groups.forEach(function (group) {
        if (group.dataset.purchaseReady === 'true') return;

        var cards = group.querySelectorAll('[data-purchase-mode]');
        var sellingPlanInput = group.querySelector('[data-selling-plan-input]');
        var sellingPlanSelect = group.querySelector('[data-selling-plan-select]');
        var sellingPlanRow = group.querySelector('[data-selling-plan-row]');
        var form = group.closest('form');
        var subscriptionConsent = form ? form.querySelector('[data-subscription-consent]') : null;

        if (cards.length === 0) return;

        group.dataset.purchaseReady = 'true';

        function syncBuyerConsent(isSubscription) {
          if (!subscriptionConsent) return;

          subscriptionConsent.hidden = !isSubscription;
        }

        function notifySellingPlanChange() {
          sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        function setMode(mode) {
          var selectedSellingPlanId = '';

          cards.forEach(function (card) {
            var isSelected = card.getAttribute('data-purchase-mode') === mode;
            card.classList.toggle('is-selected', isSelected);
            card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

            if (isSelected && mode === 'subscription') {
              selectedSellingPlanId = card.getAttribute('data-selling-plan-id') || '';
            }
          });

          if (!sellingPlanInput) return;

          if (mode === 'subscription') {
            if (sellingPlanSelect && sellingPlanSelect.value) {
              selectedSellingPlanId = sellingPlanSelect.value;
            }

            sellingPlanInput.disabled = false;
            sellingPlanInput.value = selectedSellingPlanId;

            if (sellingPlanSelect) {
              sellingPlanSelect.disabled = false;
            }

            if (sellingPlanRow) {
              sellingPlanRow.hidden = false;
            }
          } else {
            sellingPlanInput.value = '';
            sellingPlanInput.disabled = true;

            if (sellingPlanSelect) {
              sellingPlanSelect.disabled = true;
            }

            if (sellingPlanRow) {
              sellingPlanRow.hidden = true;
            }
          }

          notifySellingPlanChange();
          syncBuyerConsent(mode === 'subscription');
        }

        cards.forEach(function (card) {
          card.addEventListener('click', function () {
            setMode(card.getAttribute('data-purchase-mode'));
          });

          card.addEventListener('keydown', function (event) {
            if (event.target !== card) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;

            event.preventDefault();
            setMode(card.getAttribute('data-purchase-mode'));
          });
        });

        if (sellingPlanSelect) {
          sellingPlanSelect.addEventListener('change', function () {
            if (sellingPlanInput && !sellingPlanInput.disabled) {
              sellingPlanInput.value = sellingPlanSelect.value;
              notifySellingPlanChange();
              syncBuyerConsent(true);
            }
          });
        }

        setMode('onetime');
      });
    }

    function init(root) {
      initIntroCollapse(root);
      initGallery(root);
      initVariantOptions(root);
      initPurchaseOptions(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-product-videostrip-content"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynMealwormReviewSummary = (scope) => {
    const root = scope || document;
    const sections = [];
    if (root.matches && root.matches('[data-jppvs-review-section]')) sections.push(root);
    if (root.querySelectorAll) sections.push(...root.querySelectorAll('[data-jppvs-review-section]'));

    sections.forEach((section) => {
      if (section.dataset.jppvsReviewReady === 'true') return;
      let observer = section.jpvsReviewObserver || null;

      const syncSummary = () => {
        const widget = section.querySelector('.jdgm-rev-widg');
        if (!widget) return false;

        const hasRating = widget.hasAttribute('data-average-rating');
        const hasReviewCount = widget.hasAttribute('data-number-of-reviews');
        const rating = widget.getAttribute('data-average-rating') || '5.00';
        const reviewCount = widget.getAttribute('data-number-of-reviews') || '0';
        const sourceRows = Array.from(widget.querySelectorAll('.jdgm-histogram__row[data-rating]'));

        section.querySelectorAll('[data-jppvs-review-rating-text], [data-jppvs-review-score]').forEach((target) => {
          target.textContent = rating;
        });

        section.querySelectorAll('[data-jppvs-review-count-text]').forEach((target) => {
          target.textContent = reviewCount;
        });

        const scoreStars = section.querySelector('.jpvs-ad-score .jpvs-ad-stars');
        if (scoreStars) scoreStars.setAttribute('aria-label', 'Rated ' + rating + ' out of 5');

        sourceRows.forEach((sourceRow) => {
          const ratingValue = sourceRow.getAttribute('data-rating');
          const targetRow = section.querySelector('[data-jppvs-rating-row="' + ratingValue + '"]');
          if (!targetRow) return;

          const frequency = sourceRow.getAttribute('data-frequency') || '0';
          const percentage = sourceRow.getAttribute('data-percentage') || '0';
          const bar = targetRow.querySelector('b');
          const count = targetRow.querySelector('em');

          if (bar) bar.style.width = percentage + '%';
          if (count) count.textContent = frequency;
        });

        if (!hasRating || !hasReviewCount || sourceRows.length < 5) return false;

        section.dataset.jppvsReviewReady = 'true';
        section.removeAttribute('data-jppvs-review-observing');
        if (observer) observer.disconnect();
        section.jpvsReviewObserver = null;
        return true;
      };

      if (syncSummary()) return;
      if (section.dataset.jppvsReviewObserving === 'true') return;

      observer = new MutationObserver(() => {
        if (!syncSummary()) return;
        observer.disconnect();
      });

      section.dataset.jppvsReviewObserving = 'true';
      section.jpvsReviewObserver = observer;
      observer.observe(section, {
        attributes: true,
        attributeFilter: ['data-average-rating', 'data-number-of-reviews', 'data-frequency', 'data-percentage'],
        childList: true,
        subtree: true
      });
    });
  };

  const bootJoyprotynMealwormReviewSummary = () => {
    initializeJoyprotynMealwormReviewSummary(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootJoyprotynMealwormReviewSummary, { once: true });
  } else {
    bootJoyprotynMealwormReviewSummary();
  }

  document.addEventListener('jpvs:lazy-block:ready', (event) => {
    const block = event.detail && event.detail.block ? event.detail.block : event.target;
    initializeJoyprotynMealwormReviewSummary(block);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeJoyprotynMealwormReviewSummary(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-jppvs-review-section]').forEach((section) => {
      if (section.jpvsReviewObserver) section.jpvsReviewObserver.disconnect();
      section.jpvsReviewObserver = null;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-responsive-ad-content"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynReviewToggle = (root) => {
    if (!root || root.dataset.jpAdReviewToggleReady === 'true') return;

    const quotes = root.querySelector('.jpr-ad-review-quotes');
    const toggle = root.querySelector('[data-jp-review-toggle]');
    const label = toggle ? toggle.querySelector('[data-jp-review-toggle-label]') : null;
    if (!quotes || !toggle || !label) return;

    toggle.addEventListener('click', () => {
      const expanded = quotes.dataset.expanded !== 'true';
      quotes.dataset.expanded = String(expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? 'fewer reviews' : 'more reviews';
    });

    root.dataset.jpAdReviewToggleReady = 'true';
  };

  const initializeJoyprotynLightbox = (root) => {
    if (!root || root.dataset.jpAdLightboxReady === 'true') return;

    const dialog = root.querySelector('[data-jpr-ad-lightbox]');
    const frame = root.querySelector('.jpr-ad-lightbox-inner');
    const preview = root.querySelector('[data-jpr-ad-lightbox-image]');
    if (!dialog || !frame || !preview) return;

    const fitPreviewToViewport = () => {
      const naturalWidth = Number(preview.dataset.naturalWidth);
      const naturalHeight = Number(preview.dataset.naturalHeight);
      if (!naturalWidth || !naturalHeight) return;

      const compact = window.matchMedia('(max-width: 720px)').matches;
      const availableWidth = compact
        ? Math.max(220, window.innerWidth - 20)
        : Math.max(220, Math.min(1480, window.innerWidth - 32));
      const availableHeight = compact
        ? Math.max(220, window.innerHeight - 20)
        : Math.max(220, window.innerHeight - 32);
      const scale = Math.min(availableWidth / naturalWidth, availableHeight / naturalHeight);
      const displayWidth = Math.round(naturalWidth * scale);
      const displayHeight = Math.round(naturalHeight * scale);

      if (compact) {
        dialog.style.width = `${displayWidth}px`;
        dialog.style.height = `${displayHeight}px`;
      } else {
        dialog.style.removeProperty('width');
        dialog.style.removeProperty('height');
      }

      preview.style.setProperty('width', `${displayWidth}px`, 'important');
      preview.style.setProperty('height', `${displayHeight}px`, 'important');
      preview.style.setProperty('max-width', '100%', 'important');
      preview.style.setProperty('max-height', '100%', 'important');
      preview.style.setProperty('object-fit', 'contain', 'important');
      preview.style.setProperty('object-position', 'center', 'important');
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-jpr-ad-zoom]');
      if (trigger && root.contains(trigger)) {
        const card = trigger.closest('.jpr-ad-image-card, .jpr-ad-detail-card, .jpr-ad-outcome-card');
        const source = card ? card.querySelector('img') : null;
        if (!source) return;

        const naturalWidth = source.naturalWidth || Number(source.getAttribute('width')) || 1200;
        const naturalHeight = source.naturalHeight || Number(source.getAttribute('height')) || 900;
        preview.dataset.naturalWidth = naturalWidth;
        preview.dataset.naturalHeight = naturalHeight;
        preview.width = naturalWidth;
        preview.height = naturalHeight;
        preview.src = source.src || source.currentSrc;
        preview.alt = source.alt || '';
        fitPreviewToViewport();
        if (!dialog.open) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-jpr-ad-lightbox-close]');
      if (closeButton && root.contains(closeButton)) dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      preview.removeAttribute('src');
      preview.alt = '';
      preview.style.removeProperty('width');
      preview.style.removeProperty('height');
      preview.style.removeProperty('max-width');
      preview.style.removeProperty('max-height');
      preview.style.removeProperty('object-fit');
      preview.style.removeProperty('object-position');
      dialog.style.removeProperty('width');
      dialog.style.removeProperty('height');
      delete preview.dataset.naturalWidth;
      delete preview.dataset.naturalHeight;
    });

    window.addEventListener('resize', () => {
      if (dialog.open) fitPreviewToViewport();
    });

    root.dataset.jpAdLightboxReady = 'true';
  };

  document.querySelectorAll('[data-jpr-ad-flow]').forEach((root) => {
    initializeJoyprotynReviewToggle(root);
    initializeJoyprotynLightbox(root);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-jpr-ad-flow]');
    initializeJoyprotynReviewToggle(root);
    initializeJoyprotynLightbox(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-responsive-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var preloadedImages = {};

    function preloadImage(src) {
      if (!src || preloadedImages[src]) return;

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
      preloadedImages[src] = image;
    }

    function initIntroCollapse(root) {
      var scope = root || document;
      var intros = scope.querySelectorAll('[data-collapsible-intro]');

      intros.forEach(function (intro) {
        if (intro.dataset.collapseReady === 'true') return;

        var toggle = intro.querySelector('[data-intro-toggle]');

        if (!toggle) return;

        intro.dataset.collapseReady = 'true';

        toggle.addEventListener('click', function () {
          var expanded = intro.classList.toggle('is-expanded');

          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          toggle.textContent = expanded
            ? toggle.getAttribute('data-collapse-label')
            : toggle.getAttribute('data-expand-label');
        });
      });
    }

    function initGallery(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.jpr-pdp-hero');

      sections.forEach(function (section) {
        if (section.dataset.galleryReady === 'true') return;

        var mainImage = section.querySelector('.jpr-hero-image');
        var thumbs = section.querySelectorAll('[data-gallery-thumb]');

        if (!mainImage || thumbs.length === 0) return;

        section.dataset.galleryReady = 'true';
        mainImage.decoding = 'async';

        thumbs.forEach(function (thumb) {
          preloadImage(thumb.getAttribute('data-gallery-src'));

          thumb.addEventListener('mouseenter', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('focus', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-gallery-src');
            var srcset = thumb.getAttribute('data-gallery-srcset');
            var alt = thumb.getAttribute('data-gallery-alt') || '';

            if (!src) return;

            thumbs.forEach(function (item) {
              item.classList.remove('is-active');
              item.setAttribute('aria-current', 'false');
            });

            thumb.classList.add('is-active');
            thumb.setAttribute('aria-current', 'true');

            if (srcset) {
              mainImage.srcset = srcset;
            } else {
              mainImage.removeAttribute('srcset');
            }

            mainImage.src = src;
            mainImage.alt = alt;
          });
        });
      });
    }

    function initVariantOptions(root) {
      var scope = root || document;
      var forms = scope.querySelectorAll('.jpr-product-form');

      forms.forEach(function (form) {
        if (form.dataset.variantReady === 'true') return;

        var radios = form.querySelectorAll('[data-variant-radio]');
        var variantIdInput = form.querySelector('[data-selected-variant-id]');
        var addButton = form.querySelector('[data-add-to-cart]');
        var checkoutButton = form.querySelector('[data-checkout]');
        var priceTargets = form.querySelectorAll('[data-variant-price-target]');
        var subscriptionPriceTargets = form.querySelectorAll('[data-subscription-price-target]');
        var subscriptionCompareTargets = form.querySelectorAll('[data-subscription-compare-target]');
        var heroSection = form.closest('.jpr-pdp-hero');
        var mainImage = heroSection ? heroSection.querySelector('.jpr-hero-image') : null;
        var galleryThumbs = heroSection ? heroSection.querySelectorAll('[data-gallery-thumb]') : [];


        if (radios.length === 0) return;

        form.dataset.variantReady = 'true';

        function selectedRadio() {
          var selected = form.querySelector('[data-variant-radio]:checked');
          return selected || radios[0];
        }

        function syncVariantMedia(radio) {
          if (!radio || !mainImage) return;

          var mediaId = radio.getAttribute('data-variant-media-id') || '';
          var src = radio.getAttribute('data-variant-media-src') || '';
          var srcset = radio.getAttribute('data-variant-media-srcset') || '';
          var alt = radio.getAttribute('data-variant-media-alt') || '';

          if (!src) return;

          if (srcset) {
            mainImage.srcset = srcset;
          } else {
            mainImage.removeAttribute('srcset');
          }

          mainImage.src = src;
          mainImage.alt = alt;

          galleryThumbs.forEach(function (thumb) {
            var isActive = mediaId !== '' && thumb.getAttribute('data-gallery-media-id') === mediaId;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }

        function syncVariant(radio) {
          if (!radio) return;

          var price = radio.getAttribute('data-variant-price') || '';
          var subscriptionPrice = radio.getAttribute('data-variant-subscription-price') || price;
          var available = radio.getAttribute('data-variant-available') === 'true';

          syncVariantMedia(radio);

          if (variantIdInput && variantIdInput.value !== radio.value) {
            variantIdInput.value = radio.value;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          priceTargets.forEach(function (target) {
            target.textContent = price;
          });

          subscriptionPriceTargets.forEach(function (target) {
            target.textContent = subscriptionPrice;
          });

          subscriptionCompareTargets.forEach(function (target) {
            target.textContent = price;
          });

          if (addButton) {
            if (available) {
              addButton.disabled = false;
              addButton.textContent = addButton.getAttribute('data-add-label') + ' - ' + price;
            } else {
              addButton.disabled = true;
              addButton.textContent = addButton.getAttribute('data-sold-out-label');
            }
          }

          if (checkoutButton) {
            checkoutButton.disabled = !available;
            checkoutButton.textContent = available
              ? checkoutButton.getAttribute('data-checkout-label')
              : checkoutButton.getAttribute('data-sold-out-label');
          }
        }

        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            syncVariant(radio);
          });
        });

        syncVariant(selectedRadio());
      });
    }

    function initPurchaseOptions(root) {
      var scope = root || document;
      var groups = scope.querySelectorAll('[data-purchase-options]');

      groups.forEach(function (group) {
        if (group.dataset.purchaseReady === 'true') return;

        var modeInputs = group.querySelectorAll('[data-purchase-mode]');
        var sellingPlanInput = group.querySelector('[data-selling-plan-input]');
        var sellingPlanSelect = group.querySelector('[data-selling-plan-select]');
        var sellingPlanRow = group.querySelector('[data-selling-plan-row]');
        var form = group.closest('form');
        var subscriptionConsent = form ? form.querySelector('[data-subscription-consent]') : null;

        if (modeInputs.length === 0) return;

        group.dataset.purchaseReady = 'true';

        function syncBuyerConsent(isSubscription) {
          if (subscriptionConsent) subscriptionConsent.hidden = !isSubscription;
        }

        function notifySellingPlanChange() {
          if (sellingPlanInput) {
            sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        function setMode(mode) {
          var selectedSellingPlanId = '';

          modeInputs.forEach(function (input) {
            var isSelected = input.value === mode;
            var card = input.closest('.jpr-purchase-card');
            input.checked = isSelected;
            if (card) card.classList.toggle('is-selected', isSelected);

            if (isSelected && mode === 'subscription') {
              selectedSellingPlanId = input.getAttribute('data-selling-plan-id') || '';
            }
          });

          if (!sellingPlanInput) {
            syncBuyerConsent(false);
            return;
          }

          if (mode === 'subscription') {
            if (sellingPlanSelect && sellingPlanSelect.value) {
              selectedSellingPlanId = sellingPlanSelect.value;
            }

            sellingPlanInput.disabled = false;
            sellingPlanInput.value = selectedSellingPlanId;

            if (sellingPlanSelect) sellingPlanSelect.disabled = false;
            if (sellingPlanRow) sellingPlanRow.hidden = false;
          } else {
            sellingPlanInput.value = '';
            sellingPlanInput.disabled = true;

            if (sellingPlanSelect) sellingPlanSelect.disabled = true;
            if (sellingPlanRow) sellingPlanRow.hidden = true;
          }

          notifySellingPlanChange();
          syncBuyerConsent(mode === 'subscription');
        }

        modeInputs.forEach(function (input) {
          input.addEventListener('change', function () {
            if (input.checked) setMode(input.value);
          });
        });

        if (sellingPlanSelect) {
          sellingPlanSelect.addEventListener('change', function () {
            if (sellingPlanInput && !sellingPlanInput.disabled) {
              sellingPlanInput.value = sellingPlanSelect.value;
              notifySellingPlanChange();
              syncBuyerConsent(true);
            }
          });
        }

        var selectedMode = group.querySelector('[data-purchase-mode]:checked');
        setMode(selectedMode ? selectedMode.value : 'onetime');
      });
    }

    function init(root) {
      initIntroCollapse(root);
      initGallery(root);
      initVariantOptions(root);
      initPurchaseOptions(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-videostrip-ad-content"] && !Shopify.designMode) return;
  try {
    
  const createJoyprotynLazyManager = () => {
    const managerVersion = '2.0.0';
    const existingManager = window.JoyprotynLazyManager;
    const existingManagerIsCompatible = existingManager
      && existingManager.version === managerVersion
      && typeof existingManager.activate === 'function'
      && typeof existingManager.register === 'function'
      && typeof existingManager.retryFailedMedia === 'function'
      && typeof existingManager.unobserve === 'function';
    if (existingManagerIsCompatible) return existingManager;
    if (existingManager && typeof existingManager.destroy === 'function') existingManager.destroy();

    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const activationMargin = 800;
    const mediaTimeout = 8000;
    const pendingBlocks = new Set();
    let observer = null;
    let scanFrame = null;

    if (designMode) document.documentElement.classList.add('jpvs-design-mode');

    const collectBlocks = (scope) => {
      if (!scope) return [];
      const blocks = [];
      if (scope.matches && scope.matches('[data-jpvs-lazy-block]')) blocks.push(scope);
      if (scope.querySelectorAll) blocks.push(...scope.querySelectorAll('[data-jpvs-lazy-block]'));
      return blocks;
    };

    const waitForImage = (image) => {
      if (!image) return Promise.resolve('empty');

      return new Promise((resolve) => {
        let settled = false;
        let timer = null;

        const cleanup = () => {
          image.removeEventListener('load', handleLoad);
          image.removeEventListener('error', handleError);
          if (timer) window.clearTimeout(timer);
        };
        const finish = (status) => {
          if (settled) return;
          settled = true;
          cleanup();
          resolve(status);
        };
        const handleLoad = () => finish('loaded');
        const handleError = () => finish('error');

        if (image.complete) {
          finish(image.naturalWidth > 0 ? 'loaded' : 'error');
          return;
        }

        image.addEventListener('load', handleLoad, { once: true });
        image.addEventListener('error', handleError, { once: true });
        timer = window.setTimeout(() => finish('timeout'), mediaTimeout);
      });
    };

    const hydrateImage = (image) => {
      const lazySrc = image.dataset.jpvsLazySrc || '';
      const lazySrcset = image.dataset.jpvsLazySrcset || '';
      if (!lazySrc && !lazySrcset) return Promise.resolve('empty');

      const fallbackSrc = image.getAttribute('src') || '';
      image.dataset.jpvsMediaState = 'loading';
      image.dataset.jpvsFallbackSrc = fallbackSrc;
      image.loading = 'eager';

      try {
        if (lazySrcset) image.srcset = lazySrcset;
        if (lazySrc) image.src = lazySrc;
      } catch (error) {
        image.dataset.jpvsMediaState = 'error';
        if (lazySrc) image.dataset.jpvsRetrySrc = lazySrc;
        if (lazySrcset) image.dataset.jpvsRetrySrcset = lazySrcset;
        if (fallbackSrc) image.src = fallbackSrc;
        image.removeAttribute('data-jpvs-lazy-srcset');
        image.removeAttribute('data-jpvs-lazy-src');
        return Promise.resolve('error');
      }

      return waitForImage(image).then((status) => {
        image.removeAttribute('data-jpvs-lazy-srcset');
        image.removeAttribute('data-jpvs-lazy-src');
        image.dataset.jpvsMediaState = status;

        if (status === 'error' || status === 'timeout') {
          if (lazySrc) image.dataset.jpvsRetrySrc = lazySrc;
          if (lazySrcset) image.dataset.jpvsRetrySrcset = lazySrcset;
        }

        if (status === 'error') {
          if (fallbackSrc) image.src = fallbackSrc;
          const retryCount = Number(image.dataset.jpvsRetryCount || 0);
          if (retryCount < 1) {
            image.dataset.jpvsRetryCount = String(retryCount + 1);
            window.setTimeout(() => retryImage(image), 1600);
          }
        } else if (status === 'loaded') {
          image.removeAttribute('data-jpvs-retry-src');
          image.removeAttribute('data-jpvs-retry-srcset');
          image.removeAttribute('data-jpvs-retry-count');
        }

        if (status === 'timeout') {
          image.addEventListener('load', () => {
            image.dataset.jpvsMediaState = 'loaded';
          }, { once: true });
          image.addEventListener('error', () => {
            image.dataset.jpvsMediaState = 'error';
          }, { once: true });
        }

        return status;
      });
    };

    const hydrateMedia = (block) => {
      block.querySelectorAll('picture source[data-jpvs-lazy-srcset]').forEach((source) => {
        try {
          source.srcset = source.dataset.jpvsLazySrcset || '';
        } catch (error) {
          source.srcset = '';
        }
        source.removeAttribute('data-jpvs-lazy-srcset');
      });

      const images = Array.from(block.querySelectorAll('img[data-jpvs-lazy-src], img[data-jpvs-lazy-srcset]'));

      block.querySelectorAll('iframe[data-jpvs-lazy-src]').forEach((frame) => {
        try {
          frame.src = frame.dataset.jpvsLazySrc || '';
        } catch (error) {
          frame.removeAttribute('src');
        }
        frame.removeAttribute('data-jpvs-lazy-src');
      });

      return Promise.allSettled(images.map(hydrateImage));
    };

    const dispatchBlockReady = (block) => {
      if (!block || block.dataset.jpvsLazyState === 'ready') return;
      block.dataset.jpvsLazyState = 'ready';
      block.removeAttribute('aria-busy');
      block.dispatchEvent(
        new CustomEvent('jpvs:lazy-block:ready', {
          bubbles: true,
          detail: { block }
        })
      );
    };

    const activateSingleBlock = (block) => {
      if (!block) return Promise.resolve();
      if (block.dataset.jpvsLazyState === 'ready') return Promise.resolve();
      if (block.jpvsLazyPromise) return block.jpvsLazyPromise;

      block.dataset.jpvsLazyState = 'loading';
      block.setAttribute('aria-busy', 'true');
      pendingBlocks.delete(block);
      if (observer) observer.unobserve(block);

      let mediaPromise;
      try {
        mediaPromise = hydrateMedia(block);
      } catch (error) {
        mediaPromise = Promise.resolve([]);
      }

      block.jpvsMediaPromise = Promise.resolve(mediaPromise).finally(() => {
        block.dispatchEvent(
          new CustomEvent('jpvs:lazy-block:media-ready', {
            bubbles: true,
            detail: { block }
          })
        );
      });

      block.jpvsLazyPromise = block.jpvsMediaPromise.then(
        () =>
          new Promise((resolve) => {
            const finish = () => {
              dispatchBlockReady(block);
              resolve();
            };
            if (document.hidden || typeof window.requestAnimationFrame !== 'function') {
              window.setTimeout(finish, 0);
            } else {
              window.requestAnimationFrame(finish);
            }
          })
      );

      return block.jpvsLazyPromise;
    };

    const activate = (block) => {
      if (!block) return Promise.resolve();
      const group = block.dataset.jpvsLazyGroup;
      if (!group) return activateSingleBlock(block);

      const groupedBlocks = Array.from(document.querySelectorAll('[data-jpvs-lazy-group]')).filter(
        (candidate) => candidate.isConnected && candidate.dataset.jpvsLazyGroup === group
      );
      return Promise.all(groupedBlocks.map(activateSingleBlock));
    };

    const isNearViewport = (block) => {
      if (!block || !block.isConnected) return false;
      const rect = block.getBoundingClientRect();
      return rect.top <= window.innerHeight + activationMargin && rect.bottom >= -activationMargin;
    };

    const scanPendingBlocks = () => {
      scanFrame = null;
      pendingBlocks.forEach((block) => {
        if (!block.isConnected || block.dataset.jpvsLazyState !== 'idle') {
          pendingBlocks.delete(block);
          return;
        }
        if (isNearViewport(block)) activate(block);
      });
    };

    const schedulePendingScan = () => {
      if (scanFrame !== null) return;
      if (typeof window.requestAnimationFrame === 'function') {
        scanFrame = window.requestAnimationFrame(scanPendingBlocks);
      } else {
        scanFrame = window.setTimeout(scanPendingBlocks, 16);
      }
    };

    if ('IntersectionObserver' in window && !designMode) {
      try {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting || entry.intersectionRatio > 0) activate(entry.target);
            });
          },
          { root: null, rootMargin: `${activationMargin}px 0px`, threshold: 0.01 }
        );
      } catch (error) {
        observer = null;
      }
    }

    const register = (scope) => {
      collectBlocks(scope).forEach((block) => {
        if (block.dataset.jpvsLazyState === 'ready' || block.dataset.jpvsLazyState === 'loading') return;
        block.dataset.jpvsLazyState = 'idle';
        pendingBlocks.add(block);
        if (!observer || designMode) {
          activate(block);
          return;
        }
        try {
          observer.observe(block);
        } catch (error) {
          activate(block);
        }
      });
      schedulePendingScan();
    };

    const unobserve = (scope) => {
      collectBlocks(scope).forEach((block) => {
        pendingBlocks.delete(block);
        if (observer) observer.unobserve(block);
      });
    };

    const retryImage = (image) => {
      if (!image || !image.isConnected) return;
      if (image.dataset.jpvsRetrySrc) image.dataset.jpvsLazySrc = image.dataset.jpvsRetrySrc;
      if (image.dataset.jpvsRetrySrcset) image.dataset.jpvsLazySrcset = image.dataset.jpvsRetrySrcset;
      image.removeAttribute('data-jpvs-retry-src');
      image.removeAttribute('data-jpvs-retry-srcset');
      hydrateImage(image);
    };

    const retryFailedMedia = (scope) => {
      const root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('img[data-jpvs-retry-src], img[data-jpvs-retry-srcset]').forEach(retryImage);
    };

    const handleOnline = () => {
      retryFailedMedia(document);
      schedulePendingScan();
    };
    const handleVisibilityChange = () => {
      if (!document.hidden) schedulePendingScan();
    };
    const destroy = () => {
      if (observer) observer.disconnect();
      pendingBlocks.clear();
      window.removeEventListener('scroll', schedulePendingScan);
      window.removeEventListener('resize', schedulePendingScan);
      window.removeEventListener('pageshow', schedulePendingScan);
      window.removeEventListener('hashchange', schedulePendingScan);
      window.removeEventListener('online', handleOnline);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };

    window.addEventListener('scroll', schedulePendingScan, { passive: true });
    window.addEventListener('resize', schedulePendingScan, { passive: true });
    window.addEventListener('pageshow', schedulePendingScan);
    window.addEventListener('hashchange', schedulePendingScan);
    window.addEventListener('online', handleOnline);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    window.JoyprotynLazyManager = {
      activate,
      destroy,
      register,
      retryFailedMedia,
      unobserve,
      version: managerVersion
    };
    return window.JoyprotynLazyManager;
  };

  const joyprotynLazyManager = createJoyprotynLazyManager();

  const initializeJoyprotynVideostripVideos = (root) => {
    if (!root || root.dataset.jpvsVideoListReady === 'true') return;

    const list = root.querySelector('[data-jpvs-video-list]');
    const cards = list ? Array.from(list.querySelectorAll('.jpvs-ad-video-card:not([data-jpvs-video-clone])')) : [];
    const previous = root.querySelector('[data-jpvs-video-prev]');
    const next = root.querySelector('[data-jpvs-video-next]');
    const dialogRoot = root.closest('[data-jpvs-ad-flow]') || root;
    const videoDialog = dialogRoot.querySelector('[data-jpvs-video-lightbox]');
    const videoDialogPlayer = dialogRoot.querySelector('[data-jpvs-video-lightbox-player]');
    const videoDialogClose = dialogRoot.querySelector('[data-jpvs-video-lightbox-close]');
    if (!list || !cards.length || !previous || !next) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const compactLayout = window.matchMedia('(max-width: 720px)');
    const loopVideos = root.getAttribute('data-jpvs-video-loop') !== 'false';
    const cloneCount = loopVideos ? Math.min(cards.length, 4) : 0;
    let currentIndex = 0;
    let currentTrackIndex = cloneCount;
    let scrollTimer;
    let resizeTimer;

    cards.forEach((card, index) => {
      card.dataset.jpvsVideoIndex = String(index);
    });

    const createClone = (card) => {
      const clone = card.cloneNode(true);
      clone.dataset.jpvsVideoClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('button, video').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      return clone;
    };

    if (cloneCount > 0) {
      const leadingClones = document.createDocumentFragment();
      cards.slice(-cloneCount).forEach((card) => leadingClones.appendChild(createClone(card)));
      list.insertBefore(leadingClones, cards[0]);

      const trailingClones = document.createDocumentFragment();
      cards.slice(0, cloneCount).forEach((card) => trailingClones.appendChild(createClone(card)));
      list.appendChild(trailingClones);
    }

    const trackCards = Array.from(list.querySelectorAll('.jpvs-ad-video-card'));

    const targetScrollLeft = (card) => {
      const listRect = list.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const alignment = compactLayout.matches ? (listRect.width - cardRect.width) / 2 : 0;
      return list.scrollLeft + cardRect.left - listRect.left - alignment;
    };

    const scrollToTrackCard = (card, smooth = true) => {
      if (!card) return;
      const left = targetScrollLeft(card);
      if (!smooth || reducedMotion) {
        const previousBehavior = list.style.scrollBehavior;
        list.style.scrollBehavior = 'auto';
        list.scrollLeft = left;
        list.style.scrollBehavior = previousBehavior;
        return;
      }
      list.scrollTo({ left, behavior: 'smooth' });
    };

    const closestTrackIndex = () => {
      const listRect = list.getBoundingClientRect();
      const target = compactLayout.matches ? listRect.left + listRect.width / 2 : listRect.left;
      return trackCards.reduce(
        (closest, card, index) => {
          const cardRect = card.getBoundingClientRect();
          const anchor = compactLayout.matches ? cardRect.left + cardRect.width / 2 : cardRect.left;
          const distance = Math.abs(anchor - target);
          return distance < closest.distance ? { index, distance } : closest;
        },
        { index: 0, distance: Number.POSITIVE_INFINITY }
      ).index;
    };

    const settleLoop = () => {
      currentTrackIndex = closestTrackIndex();
      const activeCard = trackCards[currentTrackIndex];
      currentIndex = Number(activeCard.dataset.jpvsVideoIndex || 0);
      if (activeCard.dataset.jpvsVideoClone === 'true') {
        const original = cards[currentIndex];
        scrollToTrackCard(original, false);
        currentTrackIndex = trackCards.indexOf(original);
      }

      videos().forEach((video) => {
        const card = video.closest('.jpvs-ad-video-card');
        if (card && card !== cards[currentIndex]) video.pause();
      });
    };

    const move = (direction) => {
      currentTrackIndex = closestTrackIndex();
      const targetIndex = Math.max(0, Math.min(trackCards.length - 1, currentTrackIndex + direction));
      scrollToTrackCard(trackCards[targetIndex]);
    };

    const videos = () => Array.from(list.querySelectorAll('[data-jpvs-video]'));

    const pauseOtherVideos = (currentVideo) => {
      videos().forEach((video) => {
        if (video !== currentVideo) video.pause();
      });
    };

    const setCardLoading = (card, loading) => {
      if (!card) return;
      card.classList.toggle('is-loading', loading);
      if (loading) {
        card.setAttribute('aria-busy', 'true');
      } else {
        card.removeAttribute('aria-busy');
      }
    };

    const preparePoster = (poster) => {
      if (!poster || poster.dataset.jpvsPosterReady === 'true') return;
      const image = poster.querySelector('img');
      if (!image) return;

      const markLoaded = () => poster.classList.remove('has-poster-error');
      const markError = () => poster.classList.add('has-poster-error');
      image.addEventListener('load', markLoaded);
      image.addEventListener('error', markError);
      if (image.complete) {
        if (image.naturalWidth > 0) markLoaded();
        else markError();
      }
      poster.dataset.jpvsPosterReady = 'true';
    };

    const bindVideo = (video) => {
      if (!video || video.dataset.jpvsVideoBound === 'true') return;

      const card = video.closest('.jpvs-ad-video-card');
      const stopLoading = () => setCardLoading(card, false);

      video.addEventListener('loadstart', () => setCardLoading(card, true));
      video.addEventListener('waiting', () => {
        if (!video.paused) setCardLoading(card, true);
      });
      video.addEventListener('stalled', () => {
        if (!video.paused) setCardLoading(card, true);
      });
      video.addEventListener('loadeddata', stopLoading);
      video.addEventListener('canplay', stopLoading);
      video.addEventListener('error', stopLoading);

      video.addEventListener('play', () => {
        pauseOtherVideos(video);
        if (card) card.classList.add('is-playing');
      });

      video.addEventListener('playing', () => {
        stopLoading();
        if (card) card.classList.add('is-playing');
      });

      video.addEventListener('pause', () => {
        stopLoading();
        if (card) card.classList.remove('is-playing');
      });

      video.addEventListener('ended', () => {
        stopLoading();
        if (card) card.classList.remove('is-playing');
      });

      video.dataset.jpvsVideoBound = 'true';
    };

    const hydrateVideoSource = (video) => {
      const source = video ? video.querySelector('source[data-src]') : null;
      if (!source) return;

      source.src = source.dataset.src || '';
      source.removeAttribute('data-src');
      video.load();
    };

    const loadVideoFromPoster = (poster) => {
      const card = poster.closest('.jpvs-ad-video-card');
      const template = card ? card.querySelector('template') : null;
      const templateVideo = template ? template.content.querySelector('video') : null;
      if (!card || !templateVideo) return;

      const posterImage = poster.querySelector('img');
      const video = templateVideo.cloneNode(true);
      if (posterImage) video.poster = posterImage.currentSrc || posterImage.src || video.poster;
      bindVideo(video);
      poster.disabled = true;
      setCardLoading(card, true);

      let loadTimer = null;
      const clearLoadTimer = () => {
        if (!loadTimer) return;
        window.clearTimeout(loadTimer);
        loadTimer = null;
      };
      const settleLoading = () => {
        clearLoadTimer();
        setCardLoading(card, false);
      };
      const restorePoster = () => {
        const shouldRestoreFocus = document.activeElement === video;
        clearLoadTimer();
        setCardLoading(card, false);
        poster.disabled = false;
        if (video.isConnected) video.replaceWith(poster);
        preparePoster(poster);
        if (shouldRestoreFocus) poster.focus({ preventScroll: true });
      };

      video.addEventListener('loadeddata', settleLoading, { once: true });
      video.addEventListener('canplay', settleLoading, { once: true });
      video.addEventListener('error', restorePoster, { once: true });
      poster.replaceWith(video);
      hydrateVideoSource(video);
      card.classList.add('is-playing');
      pauseOtherVideos(video);
      loadTimer = window.setTimeout(settleLoading, 12000);
      if (typeof video.focus === 'function') video.focus({ preventScroll: true });

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          settleLoading();
          card.classList.remove('is-playing');
        });
      }
    };

    const openExpandedVideo = (card) => {
      if (!card || !videoDialog || !videoDialogPlayer) return;
      const inlineVideo = card.querySelector('[data-jpvs-video]');
      const template = card.querySelector('template');
      const templateVideo = template ? template.content.querySelector('video') : null;
      const sourceVideo = inlineVideo || templateVideo;
      const source = sourceVideo ? sourceVideo.querySelector('source') : null;
      const sourceUrl = source ? (source.currentSrc || source.src || source.dataset.src || '') : '';
      if (!sourceUrl) return;

      const cardPosterImage = card.querySelector('[data-jpvs-video-poster] img');
      const posterUrl = inlineVideo
        ? inlineVideo.poster
        : (cardPosterImage ? cardPosterImage.currentSrc || cardPosterImage.src : sourceVideo.poster || '');

      videos().forEach((video) => video.pause());
      videoDialogPlayer.pause();
      if (typeof videoDialogPlayer.jpvsSettleLoading === 'function') {
        videoDialogPlayer.jpvsSettleLoading();
      }
      const expandedSource = document.createElement('source');
      expandedSource.src = sourceUrl;
      expandedSource.type = source.getAttribute('type') || 'video/mp4';
      videoDialogPlayer.replaceChildren(expandedSource);
      videoDialogPlayer.poster = posterUrl;
      videoDialogPlayer.setAttribute('aria-label', sourceVideo.getAttribute('aria-label') || 'Joyprotyn video preview');
      videoDialog.classList.add('is-loading');
      videoDialog.setAttribute('aria-busy', 'true');

      let dialogTimer = null;
      const settleDialog = () => {
        videoDialog.classList.remove('is-loading');
        videoDialog.removeAttribute('aria-busy');
        if (dialogTimer) window.clearTimeout(dialogTimer);
        videoDialogPlayer.removeEventListener('loadeddata', settleDialog);
        videoDialogPlayer.removeEventListener('canplay', settleDialog);
        videoDialogPlayer.removeEventListener('playing', settleDialog);
        videoDialogPlayer.removeEventListener('error', settleDialog);
        if (videoDialogPlayer.jpvsSettleLoading === settleDialog) {
          delete videoDialogPlayer.jpvsSettleLoading;
        }
      };
      videoDialogPlayer.jpvsSettleLoading = settleDialog;
      videoDialogPlayer.addEventListener('loadeddata', settleDialog);
      videoDialogPlayer.addEventListener('canplay', settleDialog);
      videoDialogPlayer.addEventListener('playing', settleDialog);
      videoDialogPlayer.addEventListener('error', settleDialog);
      if (!videoDialog.open) videoDialog.showModal();
      videoDialogPlayer.load();
      dialogTimer = window.setTimeout(settleDialog, 12000);
      const playPromise = videoDialogPlayer.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(settleDialog);
    };

    trackCards.forEach((card) => preparePoster(card.querySelector('[data-jpvs-video-poster]')));

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));

    list.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(settleLoop, 120);
      },
      { passive: true }
    );

    list.addEventListener('keydown', (event) => {
      if (event.target !== list) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
      if (event.key === 'Home') {
        event.preventDefault();
        scrollToTrackCard(cards[0]);
      }
      if (event.key === 'End') {
        event.preventDefault();
        scrollToTrackCard(cards[cards.length - 1]);
      }
    });

    list.addEventListener('click', (event) => {
      const expand = event.target.closest('[data-jpvs-video-expand]');
      if (expand && list.contains(expand)) {
        const card = expand.closest('.jpvs-ad-video-card:not([data-jpvs-video-clone])');
        openExpandedVideo(card);
        return;
      }
      const poster = event.target.closest('[data-jpvs-video-poster]');
      if (poster && list.contains(poster)) loadVideoFromPoster(poster);
    });

    if (videoDialog && videoDialogPlayer && videoDialogClose) {
      videoDialogClose.addEventListener('click', () => videoDialog.close());
      videoDialog.addEventListener('click', (event) => {
        if (event.target === videoDialog) videoDialog.close();
      });
      videoDialog.addEventListener('close', () => {
        if (typeof videoDialogPlayer.jpvsSettleLoading === 'function') {
          videoDialogPlayer.jpvsSettleLoading();
        }
        videoDialog.classList.remove('is-loading');
        videoDialog.removeAttribute('aria-busy');
        videoDialogPlayer.pause();
        videoDialogPlayer.removeAttribute('poster');
        videoDialogPlayer.removeAttribute('aria-label');
        videoDialogPlayer.replaceChildren();
        videoDialogPlayer.load();
      });
    }

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) return;
      videos().forEach((video) => video.pause());
      if (videoDialogPlayer) videoDialogPlayer.pause();
    });

    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => scrollToTrackCard(cards[currentIndex], false), 120);
    });

    window.requestAnimationFrame(() => {
      scrollToTrackCard(cards[0], false);
      settleLoop();
    });
    root.dataset.jpvsVideoListReady = 'true';
  };

  const initializeJoyprotynVideostripReviewToggle = (root) => {
    if (!root || root.dataset.jpvsAdReviewToggleReady === 'true') return;

    const quotes = root.querySelector('.jpvs-ad-review-quotes');
    const toggle = root.querySelector('[data-jpvs-review-toggle]');
    const label = toggle ? toggle.querySelector('[data-jpvs-review-toggle-label]') : null;
    if (!quotes || !toggle || !label) return;

    toggle.addEventListener('click', () => {
      const expanded = quotes.dataset.expanded !== 'true';
      quotes.dataset.expanded = String(expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? 'fewer reviews' : 'more reviews';
    });

    root.dataset.jpvsAdReviewToggleReady = 'true';
  };

  const initializeJoyprotynVideostripLightbox = (root) => {
    if (!root || root.dataset.jpvsAdLightboxReady === 'true') return;

    const dialog = root.querySelector('[data-jpvs-ad-lightbox]');
    const frame = root.querySelector('.jpvs-ad-lightbox-inner');
    const preview = root.querySelector('[data-jpvs-ad-lightbox-image]');
    if (!dialog || !frame || !preview) return;

    const fitPreviewToViewport = () => {
      const naturalWidth = Number(preview.dataset.naturalWidth);
      const naturalHeight = Number(preview.dataset.naturalHeight);
      if (!naturalWidth || !naturalHeight) return;

      const compact = window.matchMedia('(max-width: 720px)').matches;
      const availableWidth = compact
        ? Math.max(220, window.innerWidth - 20)
        : Math.max(220, Math.min(1480, window.innerWidth - 32));
      const availableHeight = compact
        ? Math.max(220, window.innerHeight - 20)
        : Math.max(220, window.innerHeight - 32);
      const scale = Math.min(availableWidth / naturalWidth, availableHeight / naturalHeight);
      const displayWidth = Math.round(naturalWidth * scale);
      const displayHeight = Math.round(naturalHeight * scale);

      if (compact) {
        dialog.style.width = `${displayWidth}px`;
        dialog.style.height = `${displayHeight}px`;
      } else {
        dialog.style.removeProperty('width');
        dialog.style.removeProperty('height');
      }

      preview.style.setProperty('width', `${displayWidth}px`, 'important');
      preview.style.setProperty('height', `${displayHeight}px`, 'important');
      preview.style.setProperty('max-width', '100%', 'important');
      preview.style.setProperty('max-height', '100%', 'important');
      preview.style.setProperty('object-fit', 'contain', 'important');
      preview.style.setProperty('object-position', 'center', 'important');
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-jpvs-ad-zoom]');
      if (trigger && root.contains(trigger)) {
        const card = trigger.closest('.jpvs-ad-image-card, .jpvs-ad-detail-card, .jpvs-ad-outcome-card');
        const source = card ? card.querySelector('img') : null;
        if (!source) return;

        const naturalWidth = source.naturalWidth || Number(source.getAttribute('width')) || 1200;
        const naturalHeight = source.naturalHeight || Number(source.getAttribute('height')) || 900;
        preview.dataset.naturalWidth = naturalWidth;
        preview.dataset.naturalHeight = naturalHeight;
        preview.width = naturalWidth;
        preview.height = naturalHeight;
        preview.src = source.src || source.currentSrc;
        preview.alt = source.alt || '';
        fitPreviewToViewport();
        if (!dialog.open) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-jpvs-ad-lightbox-close]');
      if (closeButton && root.contains(closeButton)) dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      preview.removeAttribute('src');
      preview.alt = '';
      preview.style.removeProperty('width');
      preview.style.removeProperty('height');
      preview.style.removeProperty('max-width');
      preview.style.removeProperty('max-height');
      preview.style.removeProperty('object-fit');
      preview.style.removeProperty('object-position');
      dialog.style.removeProperty('width');
      dialog.style.removeProperty('height');
      delete preview.dataset.naturalWidth;
      delete preview.dataset.naturalHeight;
    });

    window.addEventListener('resize', () => {
      if (dialog.open) fitPreviewToViewport();
    });

    root.dataset.jpvsAdLightboxReady = 'true';
  };

  const initializeJoyprotynInteractiveScope = (scope) => {
    if (!scope) return;

    const videoRoots = [];
    if (scope.matches && scope.matches('[data-jpvs-video-root]')) videoRoots.push(scope);
    if (scope.querySelectorAll) videoRoots.push(...scope.querySelectorAll('[data-jpvs-video-root]'));
    videoRoots.forEach(initializeJoyprotynVideostripVideos);

    const flows = [];
    if (scope.matches && scope.matches('[data-jpvs-ad-flow]')) flows.push(scope);
    if (scope.closest) {
      const parentFlow = scope.closest('[data-jpvs-ad-flow]');
      if (parentFlow) flows.push(parentFlow);
    }
    if (scope.querySelectorAll) flows.push(...scope.querySelectorAll('[data-jpvs-ad-flow]'));
    Array.from(new Set(flows)).forEach(initializeJoyprotynVideostripLightbox);

    if (scope.matches && scope.matches('.jpvs-ad-reviews, [data-jppvs-review-section]')) {
      initializeJoyprotynVideostripReviewToggle(scope);
    }
    if (scope.querySelectorAll) {
      scope.querySelectorAll('.jpvs-ad-reviews, [data-jppvs-review-section]').forEach(
        initializeJoyprotynVideostripReviewToggle
      );
    }
  };

  let joyprotynAosRefreshFrame = null;
  const scheduleJoyprotynAosRefresh = () => {
    if (joyprotynAosRefreshFrame !== null) return;

    const refresh = () => {
      joyprotynAosRefreshFrame = null;
      if (window.AOS && typeof window.AOS.refresh === 'function') window.AOS.refresh();
    };

    joyprotynAosRefreshFrame = document.hidden || typeof window.requestAnimationFrame !== 'function'
      ? window.setTimeout(refresh, 0)
      : window.requestAnimationFrame(refresh);
  };

  document.addEventListener('jpvs:lazy-block:ready', (event) => {
    initializeJoyprotynInteractiveScope(event.detail && event.detail.block ? event.detail.block : event.target);
    scheduleJoyprotynAosRefresh();
  });

  const registerJoyprotynLazyBlocks = (scope) => {
    if (!scope) return;
    initializeJoyprotynInteractiveScope(scope);
    const readyBlocks = [];
    if (scope.matches && scope.matches('[data-jpvs-lazy-state="ready"]')) readyBlocks.push(scope);
    if (scope.querySelectorAll) readyBlocks.push(...scope.querySelectorAll('[data-jpvs-lazy-state="ready"]'));
    readyBlocks.forEach(initializeJoyprotynInteractiveScope);
    joyprotynLazyManager.register(scope);
  };

  const bootJoyprotynLazyBlocks = () => registerJoyprotynLazyBlocks(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootJoyprotynLazyBlocks, { once: true });
  } else {
    bootJoyprotynLazyBlocks();
  }

  document.addEventListener('shopify:section:load', (event) => {
    registerJoyprotynLazyBlocks(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    joyprotynLazyManager.unobserve(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target.closest ? event.target.closest('[data-jpvs-lazy-block]') : null;
    if (block) joyprotynLazyManager.activate(block);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-videostrip-egg-compare"] && !Shopify.designMode) return;
  try {
    
  const moveJoyprotynVideostripEggComparison = (section) => {
    if (!section || section.dataset.jpvsEggCompareMoved === 'true') return;

    const flow = document.querySelector('[data-jpvs-ad-flow]');
    const target = flow ? flow.querySelector('.jpvs-ad-outcomes') : null;
    if (!target) return;

    target.insertAdjacentElement('afterend', section);
    section.dataset.jpvsEggCompareMoved = 'true';
  };

  document.querySelectorAll('[data-jpvs-egg-compare]').forEach(moveJoyprotynVideostripEggComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jpvs-egg-compare]');
    if (section) moveJoyprotynVideostripEggComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-videostrip-feather-compare"] && !Shopify.designMode) return;
  try {
    
  const initializeJoyprotynVideostripFeatherComparison = (section) => {
    if (!section || section.dataset.jpvsFeatherCompareReady === 'true') return;

    const slider = section.querySelector('[data-jpvs-feather-slider]');
    const range = section.querySelector('.jpvs-ad-feather-range');
    if (!slider || !range) return;

    const updatePosition = () => {
      slider.style.setProperty('--jpvs-feather-position', `${range.value}%`);
    };

    range.addEventListener('input', updatePosition);
    updatePosition();
    section.dataset.jpvsFeatherCompareReady = 'true';
  };

  const moveJoyprotynVideostripFeatherComparison = (section) => {
    if (!section) return;

    const flow = document.querySelector('[data-jpvs-ad-flow]');
    const target = flow ? flow.querySelector('.jpvs-ad-outcomes') : null;
    if (!target) return;

    if (target.nextElementSibling !== section) {
      target.insertAdjacentElement('afterend', section);
    }
  };

  const prepareJoyprotynVideostripFeatherComparison = (section) => {
    initializeJoyprotynVideostripFeatherComparison(section);
    moveJoyprotynVideostripFeatherComparison(section);
    requestAnimationFrame(() => moveJoyprotynVideostripFeatherComparison(section));
    window.setTimeout(() => moveJoyprotynVideostripFeatherComparison(section), 160);
  };

  document.querySelectorAll('[data-jpvs-feather-compare]').forEach(prepareJoyprotynVideostripFeatherComparison);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-jpvs-feather-compare]');
    if (section) prepareJoyprotynVideostripFeatherComparison(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-videostrip-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var preloadedImages = {};

    function preloadImage(src) {
      if (!src || preloadedImages[src]) return;

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
      preloadedImages[src] = image;
    }

    function initIntroCollapse(root) {
      var scope = root || document;
      var intros = scope.querySelectorAll('[data-collapsible-intro]');

      intros.forEach(function (intro) {
        if (intro.dataset.collapseReady === 'true') return;

        var toggle = intro.querySelector('[data-intro-toggle]');

        if (!toggle) return;

        intro.dataset.collapseReady = 'true';

        toggle.addEventListener('click', function () {
          var expanded = intro.classList.toggle('is-expanded');

          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          toggle.textContent = expanded
            ? toggle.getAttribute('data-collapse-label')
            : toggle.getAttribute('data-expand-label');
        });
      });
    }

    function initQuantitySteppers(root) {
      var scope = root || document;
      var steppers = scope.querySelectorAll('[data-quantity-stepper]');

      steppers.forEach(function (stepper) {
        if (stepper.dataset.quantityReady === 'true') return;

        var input = stepper.querySelector('input[name="quantity"]');
        var decrease = stepper.querySelector('[data-quantity-decrease]');
        var increase = stepper.querySelector('[data-quantity-increase]');

        if (!input || !decrease || !increase) return;

        stepper.dataset.quantityReady = 'true';

        function limits() {
          var minimum = Number(input.min || 1);
          var maximum = input.max === '' ? Number.POSITIVE_INFINITY : Number(input.max);
          var increment = Number(input.step || 1);

          return {
            minimum: Number.isFinite(minimum) ? minimum : 1,
            maximum: Number.isFinite(maximum) ? maximum : Number.POSITIVE_INFINITY,
            increment: Number.isFinite(increment) && increment > 0 ? increment : 1
          };
        }

        function normalizedValue() {
          var controlLimits = limits();
          var value = Number(input.value);

          if (!Number.isFinite(value)) value = controlLimits.minimum;
          return Math.min(controlLimits.maximum, Math.max(controlLimits.minimum, value));
        }

        function syncButtons() {
          var controlLimits = limits();
          var value = normalizedValue();

          input.value = String(value);
          decrease.disabled = value <= controlLimits.minimum;
          increase.disabled = value >= controlLimits.maximum;
        }

        function changeQuantity(direction) {
          var controlLimits = limits();
          var nextValue = normalizedValue() + (controlLimits.increment * direction);

          input.value = String(Math.min(controlLimits.maximum, Math.max(controlLimits.minimum, nextValue)));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          syncButtons();
        }

        decrease.addEventListener('click', function () {
          changeQuantity(-1);
        });

        increase.addEventListener('click', function () {
          changeQuantity(1);
        });

        input.addEventListener('input', syncButtons);
        input.addEventListener('change', syncButtons);
        input.addEventListener('blur', syncButtons);
        syncButtons();
      });
    }

    function initGallery(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.jpvs-pdp-hero');

      sections.forEach(function (section) {
        if (section.dataset.galleryReady === 'true') return;

        var mainImage = section.querySelector('.jpvs-hero-image');
        var thumbs = section.querySelectorAll('[data-gallery-thumb]');

        if (!mainImage || thumbs.length === 0) return;

        section.dataset.galleryReady = 'true';
        mainImage.decoding = 'async';

        thumbs.forEach(function (thumb) {
          preloadImage(thumb.getAttribute('data-gallery-src'));

          thumb.addEventListener('mouseenter', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('focus', function () {
            preloadImage(thumb.getAttribute('data-gallery-src'));
          });

          thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-gallery-src');
            var srcset = thumb.getAttribute('data-gallery-srcset');
            var alt = thumb.getAttribute('data-gallery-alt') || '';

            if (!src) return;

            thumbs.forEach(function (item) {
              item.classList.remove('is-active');
              item.setAttribute('aria-current', 'false');
            });

            thumb.classList.add('is-active');
            thumb.setAttribute('aria-current', 'true');

            if (srcset) {
              mainImage.srcset = srcset;
            } else {
              mainImage.removeAttribute('srcset');
            }

            mainImage.src = src;
            mainImage.alt = alt;
          });
        });
      });
    }

    function initVariantOptions(root) {
      var scope = root || document;
      var forms = scope.querySelectorAll('.jpvs-product-form');

      forms.forEach(function (form) {
        if (form.dataset.variantReady === 'true') return;

        var radios = form.querySelectorAll('[data-variant-radio]');
        var variantIdInput = form.querySelector('[data-selected-variant-id]');
        var addButton = form.querySelector('[data-add-to-cart]');
        var checkoutButton = form.querySelector('[data-checkout]');
        var priceTargets = form.querySelectorAll('[data-variant-price-target]');
        var comparePriceTargets = form.querySelectorAll('[data-variant-compare-target]');
        var heroSection = form.closest('.jpvs-pdp-hero');
        var mainImage = heroSection ? heroSection.querySelector('.jpvs-hero-image') : null;
        var galleryThumbs = heroSection ? heroSection.querySelectorAll('[data-gallery-thumb]') : [];


        if (radios.length === 0) return;

        form.dataset.variantReady = 'true';

        function selectedRadio() {
          var selected = form.querySelector('[data-variant-radio]:checked');
          var requestedVariantId = new URLSearchParams(window.location.search).get('variant');

          if (requestedVariantId) {
            for (var index = 0; index < radios.length; index += 1) {
              var requestedRadio = radios[index];
              var requestedRadioAvailable = requestedRadio.getAttribute('data-variant-available') === 'true';

              if (requestedRadio.value === requestedVariantId && requestedRadioAvailable) {
                requestedRadio.checked = true;
                return requestedRadio;
              }
            }
          }

          return selected || radios[0];
        }

        function syncVariantMedia(radio) {
          if (!radio || !mainImage) return;

          var mediaId = radio.getAttribute('data-variant-media-id') || '';
          var src = radio.getAttribute('data-variant-media-src') || '';
          var srcset = radio.getAttribute('data-variant-media-srcset') || '';
          var alt = radio.getAttribute('data-variant-media-alt') || '';

          if (!src) return;

          if (srcset) {
            mainImage.srcset = srcset;
          } else {
            mainImage.removeAttribute('srcset');
          }

          mainImage.src = src;
          mainImage.alt = alt;

          galleryThumbs.forEach(function (thumb) {
            var isActive = mediaId !== '' && thumb.getAttribute('data-gallery-media-id') === mediaId;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }

        function syncVariant(radio) {
          if (!radio) return;

          var price = radio.getAttribute('data-variant-price') || '';
          var comparePrice = radio.getAttribute('data-variant-compare-price') || '';
          var hasComparePrice = radio.getAttribute('data-variant-has-compare-price') === 'true';
          var available = radio.getAttribute('data-variant-available') === 'true';

          syncVariantMedia(radio);

          priceTargets.forEach(function (target) {
            target.textContent = price;
          });

          comparePriceTargets.forEach(function (target) {
            target.textContent = comparePrice;
            target.hidden = !hasComparePrice;
          });

          if (addButton) {
            if (available) {
              addButton.disabled = false;
              addButton.textContent = addButton.getAttribute('data-add-label') + ' - ' + price;
            } else {
              addButton.disabled = true;
              addButton.textContent = addButton.getAttribute('data-sold-out-label');
            }
          }

          if (checkoutButton) {
            checkoutButton.disabled = !available;
            checkoutButton.textContent = available
              ? checkoutButton.getAttribute('data-checkout-label')
              : checkoutButton.getAttribute('data-sold-out-label');
          }

          if (variantIdInput && variantIdInput.value !== radio.value) {
            variantIdInput.value = radio.value;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            syncVariant(radio);
          });
        });

        syncVariant(selectedRadio());
      });
    }

    function sealEventElement(event) {
      var detailElement = event && event.detail ? event.detail.element : null;

      if (detailElement && detailElement.jquery) {
        detailElement = detailElement[0];
      }

      if (detailElement instanceof Element) {
        return detailElement;
      }

      return event && event.target instanceof Element ? event.target : null;
    }

    function markSealReady(element) {
      if (!element) return;

      var shell = element.matches && element.matches('[data-jpvs-seal-shell]')
        ? element
        : element.closest && element.closest('[data-jpvs-seal-shell]');

      if (!shell) return;

      shell.classList.add('is-ready');
      shell.classList.remove('is-timeout');
      shell.setAttribute('aria-busy', 'false');
    }

    function formatSealMoney(minorUnits) {
      var currency = window.Shopify && window.Shopify.currency
        ? window.Shopify.currency.active
        : 'USD';
      var locale = document.documentElement.lang || 'en';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency
        }).format(minorUnits / 100);
      } catch (error) {
        return (minorUnits / 100).toFixed(2) + ' ' + currency;
      }
    }

    function syncSealButtonPrice(event) {
      var element = sealEventElement(event);
      var form = element ? element.closest('.jpvs-product-form') : null;
      var price = event && event.detail ? Number(event.detail.price) : NaN;

      markSealReady(element);

      if (!form || !Number.isFinite(price)) return;

      var selectedVariant = form.querySelector('[data-variant-radio]:checked');
      var addButton = form.querySelector('[data-add-to-cart]');

      if (
        !selectedVariant
        || selectedVariant.getAttribute('data-variant-available') !== 'true'
        || !addButton
      ) {
        return;
      }

      addButton.textContent = addButton.getAttribute('data-add-label')
        + ' - '
        + formatSealMoney(price);
    }

    function initSealWidgets(root, refreshSeal) {
      var scope = root || document;
      var shells = scope.querySelectorAll('[data-jpvs-seal-shell]');

      shells.forEach(function (shell) {
        if (shell.dataset.sealReady === 'true') return;

        shell.dataset.sealReady = 'true';

        if (shell.querySelector('.sealsubs-container')) {
          markSealReady(shell);
          return;
        }

        var observer = new MutationObserver(function () {
          if (!shell.querySelector('.sealsubs-container')) return;

          markSealReady(shell);
          observer.disconnect();
        });

        observer.observe(shell, { childList: true, subtree: true });

        window.setTimeout(function () {
          if (shell.classList.contains('is-ready')) return;

          shell.classList.add('is-timeout');
          shell.setAttribute('aria-busy', 'false');
        }, 8000);
      });

      if (
        refreshSeal
        && window.SealSubs
        && typeof window.SealSubs.refresh === 'function'
      ) {
        window.SealSubs.refresh();
      }
    }

    if (!window.jpvsSealBridgeReady) {
      window.jpvsSealBridgeReady = true;

      document.addEventListener('sealsubs:subscription_widget_created', function (event) {
        markSealReady(sealEventElement(event));
      });

      document.addEventListener('sealsubs:selling_plan_changed', function (event) {
        markSealReady(sealEventElement(event));
      });

      document.addEventListener('sealsubs:price_update', syncSealButtonPrice);
    }

    function init(root, refreshSeal) {
      initIntroCollapse(root);
      initQuantitySteppers(root);
      initGallery(root);
      initVariantOptions(root);
      initSealWidgets(root, refreshSeal);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
